export const slidesData = [
  // ====== MODULE 1: WELCOME & INTRODUCTION (Slides 1-6) ======
  {
    id: 1,
    type: 'title',
    module: 1,
    title: 'Fundamentals of Artificial Intelligence',
    marathi: 'कृत्रिम बुद्धिमत्ता (AI) ची मूलभूत माहिती',
    subtitle: 'Empowering Maharashtra State Government Through Technology (तंत्रज्ञानाद्वारे महाराष्ट्र शासनाचे सक्षमीकरण)',
    event: '7-Hour Training Workshop (७ तासांची प्रशिक्षण कार्यशाळा)',
    audience: 'Senior Maharashtra State Government Officers (महाराष्ट्र शासनाचे वरिष्ठ अधिकारी)',
  },
  {
    id: 2,
    type: 'content',
    module: 1,
    title: 'Welcome & Session Objectives',
    marathi: 'स्वागत आणि सत्राची उद्दिष्टे',
    content: 'Welcome to an exciting journey into the world of Artificial Intelligence! This 7-hour workshop is designed specifically for senior government officers to understand, use, and lead with AI. (कृत्रिम बुद्धिमत्तेच्या जगात एका रोमांचक प्रवासात आपले स्वागत! ही ७ तासांची कार्यशाळा विशेषतः वरिष्ठ शासकीय अधिकाऱ्यांसाठी AI समजून घेणे, वापरणे आणि नेतृत्व करणे यासाठी तयार केली आहे.)',
    bullets: [
      'What is AI and how does it work? (AI म्हणजे काय आणि ते कसे काम करते?)',
      'Types of AI and Generative AI tools (AI चे प्रकार आणि जनरेटिव्ह AI साधने)',
      'How to communicate with AI using Prompts (प्रॉम्प्ट्स वापरून AI शी संवाद कसा साधावा)',
      'Impact of AI on government workforce and administration (शासकीय कर्मचारी आणि प्रशासनावर AI चा प्रभाव)',
      'Using AI for professional development and departmental efficiency (व्यावसायिक विकास आणि विभागीय कार्यक्षमतेसाठी AI चा वापर)',
      'Ethical AI: Security, Privacy, and Responsible Governance (नैतिक AI: सुरक्षा, गोपनीयता आणि जबाबदार शासन)',
    ],
    keyTakeaway: 'By end of today, you will be confident in understanding and using AI tools in your daily government work. (आजच्या दिवसाच्या शेवटी, तुम्ही तुमच्या दैनंदिन शासकीय कामात AI साधने समजून घेण्यात आणि वापरण्यात आत्मविश्वासी असाल.)',
  },
  {
    id: 3,
    type: 'content',
    module: 1,
    title: 'Workshop Agenda',
    marathi: 'कार्यशाळेचे वेळापत्रक',
    agenda: [
      { time: '09:00 - 09:20', topic: 'Welcome & Introduction (स्वागत आणि प्रस्तावना)', icon: 'flag' },
      { time: '09:20 - 10:05', topic: 'Understanding AI (AI समजून घेणे)', icon: 'brain' },
      { time: '10:05 - 10:50', topic: 'How Does AI Work? (AI कसे काम करते?)', icon: 'cog' },
      { time: '10:50 - 11:20', topic: 'Types of AI (AI चे प्रकार)', icon: 'layers' },
      { time: '11:20 - 11:35', topic: 'Tea Break (चहा विश्रांती)', icon: 'coffee' },
      { time: '11:35 - 12:50', topic: 'Generative AI & Prompting (जनरेटिव्ह AI आणि प्रॉम्प्टिंग)', icon: 'sparkles' },
      { time: '12:50 - 13:35', topic: 'Lunch Break (दुपारचे जेवण)', icon: 'utensils' },
      { time: '13:35 - 14:15', topic: 'AI Impact on Workforce (कर्मचाऱ्यांवर AI चा प्रभाव)', icon: 'users' },
      { time: '14:15 - 14:55', topic: 'AI in Your Department (तुमच्या विभागात AI)', icon: 'building' },
      { time: '14:55 - 15:20', topic: 'Professional Development with AI (AI सह व्यावसायिक विकास)', icon: 'graduation-cap' },
      { time: '15:20 - 16:00', topic: 'Ethics & Responsible AI + Closing (नैतिकता आणि जबाबदार AI + समारोप)', icon: 'shield' },
    ],
  },
  {
    id: 4,
    type: 'activity',
    module: 1,
    title: 'Icebreaker: Have You Heard of AI?',
    marathi: 'आइसब्रेकर: तुम्ही AI बद्दल ऐकले आहे का?',
    content: 'Take a moment to think: Where have you heard the term "Artificial Intelligence"? In news? In movies? In a government meeting? (एक क्षण विचार करा: तुम्ही "कृत्रिम बुद्धिमत्ता" हा शब्द कुठे ऐकला आहे? बातम्यांमध्ये? चित्रपटांमध्ये? शासकीय बैठकीत?)',
    instructions: [
      'Turn to your neighbor (तुमच्या शेजारच्या व्यक्तीकडे वळा)',
      'Discuss for 2 minutes where you have heard about AI (तुम्ही AI बद्दल कुठे ऐकले आहे यावर २ मिनिटे चर्चा करा)',
      'Share one interesting example with the group (गटासोबत एक मनोरंजक उदाहरण सामायिक करा)',
    ],
    duration: '2 Minutes (२ मिनिटे)',
    format: 'Pair Discussion (जोडीने चर्चा)',
    facilitatorTip: 'If participants use a smartphone, they are already using AI! Google Maps, autocorrect, spam filters - all are AI. (सहभागी स्मार्टफोन वापरत असतील तर ते आधीच AI वापरत आहेत! Google Maps, ऑटोकरेक्ट, स्पॅम फिल्टर - हे सर्व AI आहे.)',
  },
  {
    id: 5,
    type: 'quiz',
    module: 1,
    title: 'Quick Poll: Your Technology Experience',
    marathi: 'द्रुत सर्वेक्षण: तुमचा तंत्रज्ञान अनुभव',
    pollQuestions: [
      { question: 'Do you use a smartphone daily? (तुम्ही दररोज स्मार्टफोन वापरता का?)', options: ['Yes (हो)', 'No (नाही)'] },
      { question: 'Have you ever used Google Maps for navigation? (तुम्ही कधी Google Maps वापरले आहे का?)', options: ['Yes (हो)', 'No (नाही)'] },
      { question: 'Have you heard of ChatGPT or Gemini? (तुम्ही ChatGPT किंवा Gemini बद्दल ऐकले आहे का?)', options: ['Yes (हो)', 'No (नाही)'] },
      { question: 'Do you think AI can help in government work? (AI शासकीय कामात मदत करू शकते असे तुम्हाला वाटते का?)', options: ['Yes (हो)', 'Maybe (कदाचित)', 'Not Sure (खात्री नाही)'] },
    ],
    keyTakeaway: 'If you answered Yes to any of the above, you are already interacting with AI technology! (वरीलपैकी कोणत्याही प्रश्नाला हो उत्तर दिल्यास, तुम्ही आधीच AI तंत्रज्ञानाशी संवाद साधत आहात!)',
  },
  {
    id: 6,
    type: 'content',
    module: 1,
    title: 'Ground Rules & Session Format',
    marathi: 'नियम आणि सत्र स्वरूप',
    bullets: [
      'Ask questions anytime - no question is too basic! (कधीही प्रश्न विचारा - कोणताही प्रश्न अगदी साधा नाही!)',
      'Participate actively in all group activities (सर्व समूह कृतींमध्ये सक्रिय सहभाग घ्या)',
      'Keep phones on silent but handy - we will use them for AI exercises (फोन सायलेंट ठेवा पण जवळ ठेवा - आपण AI सरावासाठी वापरणार आहोत)',
      'There are no exams - this is a learning experience (कोणतीही परीक्षा नाही - हा एक शिकण्याचा अनुभव आहे)',
      'Everything discussed here is practical and relevant to your work (येथे चर्चा केलेले सर्व काही व्यावहारिक आणि तुमच्या कामाशी संबंधित आहे)',
    ],
    keyTakeaway: 'This workshop is interactive. Your participation makes it valuable! (ही कार्यशाळा परस्परसंवादी आहे. तुमचा सहभाग तिला मौल्यवान बनवतो!)',
  },

  // ====== MODULE 2: UNDERSTANDING AI (Slides 7-15) ======
  {
    id: 7,
    type: 'section',
    module: 2,
    title: 'Understanding AI',
    marathi: 'AI समजून घेणे',
    moduleNumber: 'Module 1 (मॉड्यूल १)',
    learningObjectives: [
      'What is AI? (AI म्हणजे काय?)',
      'Where do we find AI in everyday life? (दैनंदिन जीवनात AI कुठे आढळते?)',
      'What is NOT AI? (AI काय नाही?)',
    ],
  },
  {
    id: 8,
    type: 'content',
    module: 2,
    title: 'AI in Your Daily Life',
    marathi: 'तुमच्या दैनंदिन जीवनात AI',
    content: 'You are likely already using AI every day without realizing it! (तुम्ही कदाचित रोज AI वापरत आहात, पण तुम्हाला त्याची जाणीव नाही!)',
    bullets: [
      'Google Maps - Predicts traffic and finds best routes (Google Maps - वाहतुकीचा अंदाज लावते आणि सर्वोत्तम मार्ग शोधते)',
      'Netflix / Amazon Prime - Recommends movies based on your taste (Netflix / Amazon Prime - तुमच्या आवडीनुसार चित्रपट सुचवते)',
      'WhatsApp / Gmail - Autocorrect and suggested replies (WhatsApp / Gmail - ऑटोकरेक्ट आणि सुचवलेली उत्तरे)',
      'YouTube - Suggests videos based on your interests (YouTube - तुमच्या आवडीनुसार व्हिडिओ सुचवते)',
      'Paytm / Google Pay - Fraud detection on transactions (Paytm / Google Pay - व्यवहारांवर फसवणूक शोध)',
      'Swiggy / Zomato - Delivery time estimation using AI (Swiggy / Zomato - AI वापरून डिलिव्हरी वेळेचा अंदाज)',
    ],
    keyTakeaway: 'AI is already part of your life. Today we learn to use it deliberately for government work. (AI आधीच तुमच्या जीवनाचा भाग आहे. आज आपण शासकीय कामासाठी जाणीवपूर्वक वापरायला शिकू.)',
  },
  {
    id: 9,
    type: 'content',
    module: 2,
    title: 'AI in Maharashtra Government Today',
    marathi: 'महाराष्ट्र शासनात AI आज',
    content: 'The Maharashtra State Government is already leveraging technology in many areas: (महाराष्ट्र शासन आधीच अनेक क्षेत्रांमध्ये तंत्रज्ञानाचा लाभ घेत आहे:)',
    bullets: [
      'Aaple Sarkar Portal - Online grievance redressal for citizens (आपले सरकार पोर्टल - नागरिकांसाठी ऑनलाइन तक्रार निवारण)',
      'FASTag - Automated toll collection across state highways (FASTag - राज्य महामार्गांवर स्वयंचलित टोल संकलन)',
      'DigiLocker - Digital document verification (DigiLocker - डिजिटल दस्तऐवज पडताळणी)',
      'Maha-DBT - Direct Benefit Transfer using data analytics (Maha-DBT - डेटा विश्लेषण वापरून थेट लाभ हस्तांतरण)',
      'E-District Services - Online certificates and permits (ई-जिल्हा सेवा - ऑनलाइन प्रमाणपत्रे आणि परवानग्या)',
      'CCTV & Traffic Management - AI-powered surveillance in Mumbai and Pune (CCTV आणि वाहतूक व्यवस्थापन - मुंबई आणि पुण्यात AI आधारित देखरेख)',
    ],
    keyTakeaway: 'Maharashtra is already on the path of digital transformation. AI is the next step forward. (महाराष्ट्र आधीच डिजिटल परिवर्तनाच्या मार्गावर आहे. AI हे पुढचे पाऊल आहे.)',
  },
  {
    id: 10,
    type: 'quiz',
    module: 2,
    title: 'Assessment: Match the App to the AI Task',
    marathi: 'मूल्यांकन: ॲप आणि AI कार्य जुळवा',
    matchQuiz: {
      instruction: 'Match Column A with Column B (स्तंभ A आणि स्तंभ B जुळवा)',
      columnA: [
        { id: 'A', text: 'Google Maps (गुगल मॅप्स)' },
        { id: 'B', text: 'Amazon / Flipkart (ॲमेझॉन / फ्लिपकार्ट)' },
        { id: 'C', text: 'Gmail (जीमेल)' },
      ],
      columnB: [
        { id: '1', text: 'Filters out Spam messages automatically (स्पॅम संदेश आपोआप फिल्टर करते)' },
        { id: '2', text: 'Suggests products based on browsing history (ब्राउझिंग इतिहासावर आधारित उत्पादने सुचवते)' },
        { id: '3', text: 'Finds best route by analyzing live traffic (थेट वाहतुकीचे विश्लेषण करून सर्वोत्तम मार्ग शोधते)' },
      ],
      correctMatches: { A: '3', B: '2', C: '1' },
    },
    duration: '2 Minutes (२ मिनिटे)',
  },
  {
    id: 11,
    type: 'content',
    module: 2,
    title: 'Assessment Answers',
    marathi: 'मूल्यांकन उत्तरे',
    bullets: [
      'A. Google Maps --> Finds best route by analyzing live traffic (थेट वाहतुकीचे विश्लेषण करून सर्वोत्तम मार्ग शोधते)',
      'B. Amazon / Flipkart --> Suggests products based on browsing history (ब्राउझिंग इतिहासावर आधारित उत्पादने सुचवते)',
      'C. Gmail --> Filters out Spam messages automatically (स्पॅम संदेश आपोआप फिल्टर करते)',
    ],
    keyTakeaway: 'AI is the science of creating intelligent systems that learn from data to help us make better decisions. (AI ही डेटामधून शिकणाऱ्या बुद्धिमान प्रणाली तयार करण्याची विज्ञान आहे, जी आपल्याला चांगले निर्णय घेण्यास मदत करते.)',
  },
  {
    id: 12,
    type: 'content',
    module: 2,
    title: 'What is Artificial Intelligence?',
    marathi: 'कृत्रिम बुद्धिमत्ता म्हणजे काय?',
    content: 'AI is the ability of a computer or machine to perform tasks that normally require human intelligence. (AI म्हणजे संगणक किंवा यंत्राची अशी क्षमता जी सामान्यतः मानवी बुद्धिमत्ता आवश्यक असलेली कार्ये करू शकते.)',
    definition: 'AI = Machines that can LEARN from experience, ADAPT to new situations, and PERFORM tasks intelligently. (AI = अशी यंत्रे जी अनुभवातून शिकू शकतात, नवीन परिस्थितींशी जुळवून घेऊ शकतात आणि बुद्धिमानपणे कार्ये करू शकतात.)',
    bullets: [
      'LEARN (शिकणे) - From data and past examples (डेटा आणि मागील उदाहरणांमधून शिकते)',
      'THINK (विचार करणे) - Analyze patterns and relationships (नमुने आणि संबंध विश्लेषित करते)',
      'DECIDE (निर्णय घेणे) - Make predictions or recommendations (अंदाज किंवा शिफारसी करते)',
      'IMPROVE (सुधारणा) - Get better with more data over time (कालांतराने अधिक डेटासह सुधारते)',
    ],
    keyTakeaway: 'Think of AI as a very capable assistant that learns from experience - just like a junior officer who improves over time. (AI ला अनुभवातून शिकणारा एक अत्यंत सक्षम सहाय्यक समजा - अगदी कालांतराने सुधारणाऱ्या कनिष्ठ अधिकाऱ्यासारखा.)',
  },
  {
    id: 13,
    type: 'quiz',
    module: 2,
    title: 'Quiz: What is NOT AI?',
    marathi: 'प्रश्नमंजुषा: AI काय नाही?',
    trueFalse: [
      {
        statement: 'A digital wall clock showing the time (वेळ दाखवणारे डिजिटल भिंतीचे घड्याळ)',
        answer: false,
        explanation: 'A clock follows fixed mechanical rules - it does not learn or adapt. (घड्याळ निश्चित यांत्रिक नियमांचे पालन करते - ते शिकत नाही किंवा जुळवून घेत नाही.)',
      },
      {
        statement: 'A smartphone keyboard predicting your next word (तुमचा पुढचा शब्द सांगणारा स्मार्टफोन कीबोर्ड)',
        answer: true,
        explanation: 'The keyboard learns your typing habits and improves predictions over time - this is AI! (कीबोर्ड तुमच्या टायपिंग सवयी शिकतो आणि कालांतराने अंदाज सुधारतो - हे AI आहे!)',
      },
      {
        statement: 'A basic desktop calculator (एक साधा डेस्कटॉप कॅल्क्युलेटर)',
        answer: false,
        explanation: 'A calculator performs exact mathematical operations - it does not recognize patterns or learn. (कॅल्क्युलेटर अचूक गणितीय क्रिया करतो - तो नमुने ओळखत नाही किंवा शिकत नाही.)',
      },
      {
        statement: 'Spam filter in your email (तुमच्या ईमेलमधील स्पॅम फिल्टर)',
        answer: true,
        explanation: 'The spam filter learns from patterns in emails to identify and block spam - this is AI! (स्पॅम फिल्टर ईमेलमधील नमुन्यांमधून शिकतो आणि स्पॅम ओळखतो व रोखतो - हे AI आहे!)',
      },
    ],
  },
  {
    id: 14,
    type: 'content',
    module: 2,
    title: 'AI vs Not AI: The Key Difference',
    marathi: 'AI आणि AI नसलेले: मुख्य फरक',
    comparison: {
      left: {
        title: 'AI (कृत्रिम बुद्धिमत्ता)',
        items: [
          'Learns from data (डेटामधून शिकते)',
          'Improves over time (कालांतराने सुधारते)',
          'Recognizes patterns (नमुने ओळखते)',
          'Adapts to new situations (नवीन परिस्थितींशी जुळवून घेते)',
          'Example: Voice assistant, spam filter (उदाहरण: व्हॉइस असिस्टंट, स्पॅम फिल्टर)',
        ],
      },
      right: {
        title: 'NOT AI (AI नाही)',
        items: [
          'Follows fixed rules (निश्चित नियमांचे पालन करते)',
          'Never changes behavior (वर्तन कधीच बदलत नाही)',
          'No pattern recognition (नमुना ओळख नाही)',
          'Same output every time (प्रत्येक वेळी समान आउटपुट)',
          'Example: Calculator, clock, fan (उदाहरण: कॅल्क्युलेटर, घड्याळ, पंखा)',
        ],
      },
    },
    keyTakeaway: 'Rule of Thumb: Machines that LEARN and get smarter over time are AI. Machines that follow FIXED rules are NOT AI. (अंगठ्याचा नियम: कालांतराने शिकणारी आणि हुशार होणारी यंत्रे AI आहेत. निश्चित नियमांचे पालन करणारी यंत्रे AI नाहीत.)',
  },
  {
    id: 15,
    type: 'activity',
    module: 2,
    title: 'Discussion: AI Around You',
    marathi: 'चर्चा: तुमच्या आजूबाजूला AI',
    content: 'Think about your daily routine from morning to evening. Identify at least 3 instances where you interact with AI. (सकाळपासून संध्याकाळपर्यंतच्या तुमच्या दैनंदिन दिनचर्येचा विचार करा. तुम्ही AI शी संवाद साधता अशा किमान ३ प्रसंगांची ओळख करा.)',
    instructions: [
      'Think for 1 minute about your daily routine (तुमच्या दैनंदिन दिनचर्येबद्दल १ मिनिट विचार करा)',
      'Identify 3 AI interactions, e.g., phone unlock with face, traffic suggestions, news feed (३ AI संवाद ओळखा, जसे चेहऱ्याने फोन अनलॉक, वाहतूक सूचना, बातम्यांचा फीड)',
      'Share your best example with the group (तुमचे सर्वोत्तम उदाहरण गटासोबत सामायिक करा)',
    ],
    duration: '3 Minutes (३ मिनिटे)',
    format: 'Group Discussion (समूह चर्चा)',
    facilitatorTip: 'Even simple things like phone autocorrect, face unlock, and voice typing are AI-powered. (फोन ऑटोकरेक्ट, फेस अनलॉक आणि व्हॉइस टायपिंग यासारख्या साध्या गोष्टीही AI वर चालतात.)',
  },

  // ====== MODULE 3: HOW AI WORKS (Slides 16-24) ======
  {
    id: 16,
    type: 'section',
    module: 3,
    title: 'How Does AI Work?',
    marathi: 'AI कसे काम करते?',
    moduleNumber: 'Module 2 (मॉड्यूल २)',
    learningObjectives: [
      'The role of Data in AI (AI मध्ये डेटाची भूमिका)',
      'Machine Learning vs Deep Learning (मशीन लर्निंग vs डीप लर्निंग)',
      'How AI learns from examples (AI उदाहरणांमधून कसे शिकते)',
    ],
  },
  {
    id: 17,
    type: 'content',
    module: 3,
    title: 'Solving the Case with Data',
    marathi: 'डेटाच्या मदतीने गुन्हा सोडवणे',
    content: 'Imagine you are an investigating officer solving a case... (कल्पना करा तुम्ही एक तपास अधिकारी आहात आणि गुन्हा सोडवत आहात...)',
    cases: [
      { label: 'CASE 1 (प्रकरण १)', icon: 'x', text: 'Zero information (शून्य माहिती)', result: 'Very difficult to solve (सोडवणे अत्यंत कठीण)', color: 'red' },
      { label: 'CASE 2 (प्रकरण २)', icon: 'alert', text: 'A single fingerprint (एक बोटाचा ठसा)', result: 'Challenging, but possible (आव्हानात्मक, पण शक्य)', color: 'yellow' },
      { label: 'CASE 3 (प्रकरण ३)', icon: 'check', text: 'Fingerprints + CCTV + Witnesses (बोटांचे ठसे + CCTV + साक्षीदार)', result: 'Much easier to solve! (सोडवणे खूप सोपे!)', color: 'green' },
    ],
    keyTakeaway: 'Just like in police investigation: More data = Better decisions. AI works the same way! (पोलीस तपासाप्रमाणेच: अधिक डेटा = चांगले निर्णय. AI ही अशाच प्रकारे काम करते!)',
  },
  {
    id: 18,
    type: 'content',
    module: 3,
    title: 'The Power of Data in Government',
    marathi: 'शासनात डेटाची शक्ती',
    content: 'Just like an officer needs information to solve cases, AI needs DATA to make smart decisions. (अधिकाऱ्याला गुन्हे सोडवण्यासाठी माहिती लागते तसेच, AI ला हुशार निर्णय घेण्यासाठी डेटा लागतो.)',
    bullets: [
      'Census data - Population patterns and demographics (जनगणना डेटा - लोकसंख्या नमुने आणि जनसांख्यिकी)',
      'Traffic camera feeds - Real-time road conditions (वाहतूक कॅमेरा फीड - रस्त्यांची वास्तविक वेळेची स्थिती)',
      'Public grievance applications - Citizen complaints and issues (नागरिक तक्रार अर्ज - नागरिकांच्या तक्रारी आणि समस्या)',
      'Budget and financial records - Revenue and expenditure data (अर्थसंकल्प आणि आर्थिक नोंदी - महसूल आणि खर्चाचा डेटा)',
      'Healthcare statistics - Disease patterns and hospital data (आरोग्य आकडेवारी - रोगांचे नमुने आणि रुग्णालय डेटा)',
      'Land records - Property ownership and survey data (जमीन नोंदी - मालमत्ता मालकी आणि सर्वेक्षण डेटा)',
    ],
    keyTakeaway: 'The more high-quality data AI has, the better it works. Maharashtra has enormous data that AI can analyze. (AI कडे जितका अधिक दर्जेदार डेटा असेल, तितके ते चांगले काम करते. महाराष्ट्राकडे प्रचंड डेटा आहे जो AI विश्लेषित करू शकतो.)',
  },
  {
    id: 19,
    type: 'content',
    module: 3,
    title: 'Maharashtra Government Data Sources',
    marathi: 'महाराष्ट्र शासन डेटा स्रोत',
    content: 'Maharashtra generates massive amounts of data every day across departments: (महाराष्ट्र दररोज विभागांमध्ये प्रचंड प्रमाणात डेटा तयार करतो:)',
    bullets: [
      'Revenue Department - 3.2 crore land records across 36 districts (महसूल विभाग - ३६ जिल्ह्यांमध्ये ३.२ कोटी जमीन नोंदी)',
      'Health Department - Daily patient records from 1,800+ PHCs (आरोग्य विभाग - १,८०० हून अधिक PHC मधून दैनंदिन रुग्ण नोंदी)',
      'Education Department - Data from 1 lakh+ schools and colleges (शिक्षण विभाग - १ लाखाहून अधिक शाळा आणि महाविद्यालयांचा डेटा)',
      'Agriculture Department - Crop data, soil health, weather patterns across all talukas (कृषी विभाग - सर्व तालुक्यांमधील पीक डेटा, मृदा आरोग्य, हवामान नमुने)',
      'Urban Development - Building permits, water supply, waste management data (नगरविकास - बांधकाम परवानग्या, पाणी पुरवठा, कचरा व्यवस्थापन डेटा)',
      'Police Department - FIR data, traffic violations, CCTV surveillance feeds (पोलीस विभाग - FIR डेटा, वाहतूक उल्लंघन, CCTV देखरेख फीड)',
    ],
    keyTakeaway: 'This data, when analyzed by AI, can transform how Maharashtra governs and serves its 12+ crore citizens. (या डेटाचे AI द्वारे विश्लेषण केल्यास, महाराष्ट्र आपल्या १२ कोटींहून अधिक नागरिकांचे शासन आणि सेवा कशी करतो ते बदलू शकते.)',
  },
  {
    id: 20,
    type: 'quiz',
    module: 3,
    title: 'Quiz: How Does YouTube Know?',
    marathi: 'प्रश्नमंजुषा: YouTube ला कसे कळते?',
    questions: [
      {
        question: 'How does YouTube know which video to suggest to you? (YouTube ला कोणता व्हिडिओ सुचवायचा हे कसे कळते?)',
        options: [
          'It picks videos randomly (ते व्हिडिओ यादृच्छिकपणे निवडते)',
          'It looks at what videos you watched and liked in the past (तुम्ही पूर्वी पाहिलेले आणि आवडलेले व्हिडिओ पाहते)',
          'It only shows the most popular videos in the country (ते फक्त देशातील सर्वात लोकप्रिय व्हिडिओ दाखवते)',
          'A YouTube employee manually selects videos for you (YouTube चा कर्मचारी तुमच्यासाठी हाताने व्हिडिओ निवडतो)',
        ],
        correct: 1,
        explanation: 'YouTube uses your past data (watch history, likes, search queries) to learn your preferences and suggest relevant videos. This is AI in action! (YouTube तुमचा मागील डेटा (पाहण्याचा इतिहास, लाइक्स, शोध) वापरून तुमच्या आवडी शिकतो आणि संबंधित व्हिडिओ सुचवतो. हे AI कार्यरत आहे!)',
      },
    ],
  },
  {
    id: 21,
    type: 'content',
    module: 3,
    title: 'How AI Learns: Machine Learning',
    marathi: 'AI कसे शिकते: मशीन लर्निंग',
    content: 'Think of Machine Learning like a Junior Clerk learning from a manual... (मशीन लर्निंग हे मॅन्युअलमधून शिकणाऱ्या कनिष्ठ लिपिकासारखे समजा...)',
    comparison: {
      left: {
        title: 'Junior Clerk (कनिष्ठ लिपिक)',
        items: [
          'Given specific instructions / manual (विशिष्ट सूचना / मॅन्युअल दिले जाते)',
          'Provided files and data to work with (काम करण्यासाठी फाइल्स आणि डेटा दिला जातो)',
          'Follows steps to produce output (आउटपुट तयार करण्यासाठी पायऱ्यांचे अनुसरण करतो)',
          'Sorts files by date, category (तारीख, श्रेणीनुसार फाइल्स वर्गीकृत करतो)',
          'Gets faster with practice (सरावाने वेगवान होतो)',
        ],
      },
      right: {
        title: 'Machine Learning (मशीन लर्निंग)',
        items: [
          'Given specific algorithms / instructions (विशिष्ट अल्गोरिदम / सूचना दिल्या जातात)',
          'Trained on structured data / examples (संरचित डेटा / उदाहरणांवर प्रशिक्षित केले जाते)',
          'Follows patterns to make predictions (अंदाज बांधण्यासाठी नमुन्यांचे अनुसरण करते)',
          'Predicts traffic patterns, crop yields (वाहतूक नमुने, पीक उत्पन्नाचा अंदाज लावते)',
          'Improves with more data (अधिक डेटासह सुधारते)',
        ],
      },
    },
    keyTakeaway: 'Machine Learning = Teaching computers using specific examples and instructions, just like training a new clerk. (मशीन लर्निंग = विशिष्ट उदाहरणे आणि सूचना वापरून संगणकांना शिकवणे, नवीन लिपिकाला प्रशिक्षण देण्यासारखेच.)',
  },
  {
    id: 22,
    type: 'content',
    module: 3,
    title: 'How AI Learns: Deep Learning',
    marathi: 'AI कसे शिकते: डीप लर्निंग',
    content: 'Think of Deep Learning as an Experienced Senior Officer... (डीप लर्निंग हे अनुभवी वरिष्ठ अधिकाऱ्यासारखे समजा...)',
    comparison: {
      left: {
        title: 'Senior Officer (वरिष्ठ अधिकारी)',
        items: [
          'Does not need step-by-step manual (टप्प्याटप्प्याने मॅन्युअलची गरज नाही)',
          'Looks at complex situations holistically (जटिल परिस्थिती समग्रपणे पाहतो)',
          'Finds hidden patterns from experience (अनुभवातून लपलेले नमुने शोधतो)',
          'Makes sophisticated judgments (सखोल निर्णय घेतो)',
          'Handles ambiguity and nuance (अस्पष्टता आणि सूक्ष्मता हाताळतो)',
        ],
      },
      right: {
        title: 'Deep Learning (डीप लर्निंग)',
        items: [
          'Processes massive unstructured data (प्रचंड असंरचित डेटावर प्रक्रिया करते)',
          'Finds complex patterns automatically (जटिल नमुने आपोआप शोधते)',
          'Used for sophisticated AI tasks (प्रगत AI कार्यांसाठी वापरले जाते)',
          'Facial recognition, language understanding (चेहरा ओळख, भाषा समजणे)',
          'Powers ChatGPT, Google Translate (ChatGPT, Google Translate ला सामर्थ्य देते)',
        ],
      },
    },
    keyTakeaway: 'Deep Learning handles complex tasks that need intuition - like understanding language, recognizing faces, or analyzing medical images. (डीप लर्निंग अंतर्ज्ञान आवश्यक असलेली जटिल कार्ये हाताळते - जसे भाषा समजणे, चेहरे ओळखणे, किंवा वैद्यकीय प्रतिमांचे विश्लेषण.)',
  },
  {
    id: 23,
    type: 'content',
    module: 3,
    title: 'Machine Learning vs Deep Learning',
    marathi: 'मशीन लर्निंग vs डीप लर्निंग',
    tableData: {
      headers: ['Feature (वैशिष्ट्य)', 'Machine Learning (मशीन लर्निंग)', 'Deep Learning (डीप लर्निंग)'],
      rows: [
        ['Data needed (डेटा आवश्यकता)', 'Moderate / structured (मध्यम / संरचित)', 'Massive / any format (प्रचंड / कोणतेही स्वरूप)'],
        ['Learning style (शिकण्याची शैली)', 'From specific examples (विशिष्ट उदाहरणांमधून)', 'Finds patterns itself (स्वतः नमुने शोधते)'],
        ['Analogy (उदाहरण)', 'Junior Clerk with manual (मॅन्युअलसह कनिष्ठ लिपिक)', 'Senior Officer with experience (अनुभवी वरिष्ठ अधिकारी)'],
        ['Government use (शासकीय वापर)', 'Budget forecasting, crop prediction (अर्थसंकल्प अंदाज, पीक अंदाज)', 'Document reading, face recognition (दस्तऐवज वाचन, चेहरा ओळख)'],
        ['Complexity (जटिलता)', 'Simpler tasks (सोपी कार्ये)', 'Complex tasks (जटिल कार्ये)'],
        ['Example (उदाहरण)', 'Spam filtering (स्पॅम फिल्टरिंग)', 'ChatGPT, language translation (ChatGPT, भाषा भाषांतर)'],
      ],
    },
  },
  {
    id: 24,
    type: 'quiz',
    module: 3,
    title: 'Knowledge Check: Fill in the Blanks',
    marathi: 'ज्ञान तपासणी: रिकाम्या जागा भरा',
    fillBlanks: [
      { sentence: 'AI needs _______ to learn and make decisions. (AI ला शिकण्यासाठी आणि निर्णय घेण्यासाठी _______ लागतो.)', answer: 'Data (डेटा)', hint: 'What does a police officer need to solve a case? (पोलीस अधिकाऱ्याला गुन्हा सोडवण्यासाठी काय लागते?)' },
      { sentence: 'Machine Learning teaches computers using specific _______. (मशीन लर्निंग विशिष्ट _______ वापरून संगणकांना शिकवते.)', answer: 'Examples (उदाहरणे)', hint: 'Like a clerk learning from a manual with... (मॅन्युअलमधून शिकणाऱ्या लिपिकासारखे...)' },
      { sentence: '_______ Learning finds complex patterns in massive amounts of data. (_______ लर्निंग प्रचंड डेटामध्ये जटिल नमुने शोधते.)', answer: 'Deep (डीप)', hint: 'Like a senior officer with years of experience... (अनेक वर्षांच्या अनुभवासह वरिष्ठ अधिकाऱ्यासारखे...)' },
      { sentence: 'The more _______ data AI has, the better it works. (AI कडे जितका अधिक _______ डेटा असेल, तितके ते चांगले काम करते.)', answer: 'Quality (दर्जेदार)', hint: 'Not just quantity, but also... (केवळ प्रमाणच नाही, तर...)' },
    ],
  },

  // ====== MODULE 4: TYPES OF AI (Slides 25-30) ======
  {
    id: 25,
    type: 'section',
    module: 4,
    title: 'Types of AI',
    marathi: 'AI चे प्रकार',
    moduleNumber: 'Module 3 (मॉड्यूल ३)',
    learningObjectives: [
      'Narrow AI vs General AI (संकुचित AI vs सामान्य AI)',
      'A brief history of AI (AI चा संक्षिप्त इतिहास)',
      'AI milestones in India (भारतातील AI चे महत्त्वाचे टप्पे)',
    ],
  },
  {
    id: 26,
    type: 'content',
    module: 4,
    title: 'Narrow AI vs General AI',
    marathi: 'संकुचित AI vs सामान्य AI',
    content: 'Google Translate can translate English to Marathi brilliantly... but can it DRIVE A CAR? A chess computer is brilliant at chess... but can it WRITE A GOVERNMENT POLICY? (Google Translate इंग्रजीचे मराठीत उत्कृष्ट भाषांतर करू शकते... पण ते कार चालवू शकते का? बुद्धिबळ संगणक बुद्धिबळात अलौकिक आहे... पण तो शासकीय धोरण लिहू शकतो का?)',
    comparison: {
      left: {
        title: 'Narrow AI (संकुचित AI)',
        items: [
          'Good at ONE specific task (एका विशिष्ट कार्यात चांगले)',
          'EXISTS TODAY (आज अस्तित्वात आहे)',
          'Voice assistants - Alexa, Siri (व्हॉइस असिस्टंट - Alexa, Siri)',
          'Language translation (भाषा भाषांतर)',
          'Traffic route optimization (वाहतूक मार्ग अनुकूलन)',
          'Spam detection (स्पॅम शोध)',
        ],
      },
      right: {
        title: 'General AI (सामान्य AI)',
        items: [
          'Can do ANY intellectual task (कोणतेही बौद्धिक कार्य करू शकते)',
          'DOES NOT EXIST YET (अजून अस्तित्वात नाही)',
          'Would think like a human brain (मानवी मेंदूसारखे विचार करेल)',
          'Handle any task thrown at it (कोणतेही कार्य हाताळू शकेल)',
          'Still science fiction (अजूनही विज्ञान कथा)',
          'Decades away, if ever (अनेक दशके दूर, कधी शक्य झाल्यास)',
        ],
      },
    },
    keyTakeaway: 'ALL AI today is Narrow AI. Each AI tool is specialized for specific tasks. General AI is still science fiction. (आजचे सर्व AI हे संकुचित AI आहे. प्रत्येक AI साधन विशिष्ट कार्यांसाठी विशेषीकृत आहे. सामान्य AI अजूनही विज्ञान कथा आहे.)',
  },
  {
    id: 27,
    type: 'quiz',
    module: 4,
    title: 'Assessment: Narrow AI or General AI?',
    marathi: 'मूल्यांकन: संकुचित AI की सामान्य AI?',
    questions: [
      {
        question: 'A government app that detects crop diseases from photos (फोटोंमधून पिकांचे रोग शोधणारे शासकीय ॲप)',
        options: ['Narrow AI (संकुचित AI)', 'General AI (सामान्य AI)'],
        correct: 0,
        explanation: 'This is Narrow AI - it does one specific task (crop disease detection) very well. (हे संकुचित AI आहे - ते एक विशिष्ट कार्य (पीक रोग शोध) अतिशय चांगले करते.)',
      },
      {
        question: 'A robot that can draft policies, cook food, drive a car, and manage a team just like a human (धोरणे तयार करणारा, स्वयंपाक करणारा, कार चालवणारा आणि टीम व्यवस्थापित करणारा रोबोट)',
        options: ['Narrow AI (संकुचित AI)', 'General AI (सामान्य AI)'],
        correct: 1,
        explanation: 'This would be General AI - but it does NOT exist yet. This is still science fiction. (हे सामान्य AI असेल - पण ते अजून अस्तित्वात नाही. हे अजूनही विज्ञान कथा आहे.)',
      },
      {
        question: 'ChatGPT that can write emails, summarize documents, and answer questions (ईमेल लिहणारे, दस्तऐवजांचा सारांश काढणारे आणि प्रश्नांची उत्तरे देणारे ChatGPT)',
        options: ['Narrow AI (संकुचित AI)', 'General AI (सामान्य AI)'],
        correct: 0,
        explanation: 'Despite being versatile with text, ChatGPT is still Narrow AI - it specializes in language tasks and cannot drive a car or perform physical tasks. (मजकुरात बहुमुखी असूनही, ChatGPT अजूनही संकुचित AI आहे - ते भाषा कार्यांमध्ये विशेषज्ञ आहे आणि कार चालवू शकत नाही किंवा शारीरिक कार्ये करू शकत नाही.)',
      },
    ],
  },
  {
    id: 28,
    type: 'content',
    module: 4,
    title: 'A Quick History of AI',
    marathi: 'AI चा संक्षिप्त इतिहास',
    timeline: [
      { year: '1950', event: 'Alan Turing asks: "Can machines think?" - Birth of AI concept (ॲलन ट्युरिंग विचारतो: "यंत्रे विचार करू शकतात का?" - AI संकल्पनेचा जन्म)', icon: 'lightbulb' },
      { year: '1960s-70s', event: 'Early chatbots and rule-based computer programs developed (सुरुवातीचे चॅटबॉट्स आणि नियम-आधारित संगणक कार्यक्रम विकसित)', icon: 'message-square' },
      { year: '1980s-90s', event: '"AI Winter" - Slow period due to lack of computing power ("AI हिवाळा" - संगणकीय शक्तीच्या अभावामुळे मंद काळ)', icon: 'snowflake' },
      { year: '2010-2020', event: 'Rapid growth: Big data + powerful computers revolutionize AI (जलद वाढ: बिग डेटा + शक्तिशाली संगणकांनी AI मध्ये क्रांती केली)', icon: 'rocket' },
      { year: '2022-Now', event: 'ChatGPT era: AI becomes accessible to everyone (ChatGPT युग: AI सर्वांसाठी सुलभ झाले)', icon: 'sparkles' },
    ],
  },
  {
    id: 29,
    type: 'content',
    module: 4,
    title: 'AI in India: Key Milestones',
    marathi: 'भारतातील AI: महत्त्वाचे टप्पे',
    bullets: [
      '2018: NITI Aayog releases National AI Strategy #AIForAll (२०१८: नीती आयोगाने राष्ट्रीय AI धोरण #AIForAll प्रकाशित केले)',
      '2020: India AI Portal launched for AI resources and research (२०२०: AI संसाधने आणि संशोधनासाठी भारत AI पोर्टल लॉन्च)',
      '2021: AI used in COVID-19 contact tracing and vaccine distribution (२०२१: COVID-19 संपर्क शोध आणि लस वितरणात AI चा वापर)',
      '2022: UPI fraud detection using AI saves thousands of crores (२०२२: AI वापरून UPI फसवणूक शोधामुळे हजारो कोटी वाचले)',
      '2023: IndiaAI Mission launched with Rs 10,000+ crore budget (२०२३: रु. १०,०००+ कोटी अर्थसंकल्पासह IndiaAI मिशन लॉन्च)',
      '2024: AI integration in Aadhaar, DigiYatra, and Smart City projects (२०२४: आधार, DigiYatra आणि स्मार्ट सिटी प्रकल्पांमध्ये AI एकत्रीकरण)',
      '2025: Maharashtra adopts AI-powered grievance management and traffic systems (२०२५: महाराष्ट्राने AI-आधारित तक्रार व्यवस्थापन आणि वाहतूक प्रणाली स्वीकारली)',
    ],
    keyTakeaway: 'India is investing heavily in AI. As government officers, you are at the forefront of this transformation. (भारत AI मध्ये मोठी गुंतवणूक करत आहे. शासकीय अधिकारी म्हणून, तुम्ही या परिवर्तनाच्या अग्रभागी आहात.)',
  },
  {
    id: 30,
    type: 'quiz',
    module: 4,
    title: 'Quick Recap: Modules 1-3',
    marathi: 'द्रुत पुनरावलोकन: मॉड्यूल १-३',
    questions: [
      {
        question: 'What does AI need most to learn and make decisions? (AI ला शिकण्यासाठी आणि निर्णय घेण्यासाठी सर्वात जास्त काय लागते?)',
        options: ['Electricity (वीज)', 'Data (डेटा)', 'Internet (इंटरनेट)', 'Human commands every time (प्रत्येक वेळी मानवी आज्ञा)'],
        correct: 1,
        explanation: 'AI needs DATA to learn patterns and make intelligent decisions. (AI ला नमुने शिकण्यासाठी आणि बुद्धिमान निर्णय घेण्यासाठी डेटा लागतो.)',
      },
      {
        question: 'Which type of AI exists today? (आज कोणत्या प्रकारचे AI अस्तित्वात आहे?)',
        options: ['General AI (सामान्य AI)', 'Super AI (सुपर AI)', 'Narrow AI (संकुचित AI)', 'Conscious AI (जागरूक AI)'],
        correct: 2,
        explanation: 'All AI today is Narrow AI - specialized for specific tasks. (आजचे सर्व AI हे संकुचित AI आहे - विशिष्ट कार्यांसाठी विशेषीकृत.)',
      },
      {
        question: 'Machine Learning is like a... (मशीन लर्निंग हे ...सारखे आहे)',
        options: ['Senior officer with experience (अनुभवी वरिष्ठ अधिकारी)', 'Junior clerk learning from a manual (मॅन्युअलमधून शिकणारा कनिष्ठ लिपिक)', 'Robot replacing humans (मानवांची जागा घेणारा रोबोट)', 'Magic spell (जादूचा मंत्र)'],
        correct: 1,
        explanation: 'ML learns from specific examples and instructions, like a junior clerk following a manual. (ML विशिष्ट उदाहरणे आणि सूचनांमधून शिकते, मॅन्युअलचे अनुसरण करणाऱ्या कनिष्ठ लिपिकाप्रमाणे.)',
      },
    ],
  },

  // ====== TEA BREAK (Slide 31) ======
  {
    id: 31,
    type: 'break',
    module: 0,
    title: 'Tea Break',
    marathi: 'चहा विश्रांती',
    duration: '15 Minutes (१५ मिनिटे)',
    message: 'Stretch, refresh, and discuss what you have learned so far with your colleagues! (ताणून मोकळे व्हा, ताजेतवाने व्हा आणि आतापर्यंत शिकलेल्या गोष्टींबद्दल सहकाऱ्यांशी चर्चा करा!)',
    funFact: 'Did you know? The first AI program was written in 1951 - over 70 years ago! But it took decades of data growth to make AI truly powerful. (तुम्हाला माहीत आहे का? पहिला AI कार्यक्रम १९५१ मध्ये लिहिला गेला - ७० वर्षांपूर्वी! पण AI खरोखर शक्तिशाली बनवण्यासाठी अनेक दशकांचा डेटा वाढ लागला.)',
  },

  // ====== MODULE 5: GENERATIVE AI & PROMPTING (Slides 32-45) ======
  {
    id: 32,
    type: 'section',
    module: 5,
    title: 'Generative AI & Prompting',
    marathi: 'जनरेटिव्ह AI आणि प्रॉम्प्टिंग',
    moduleNumber: 'Module 4 (मॉड्यूल ४)',
    learningObjectives: [
      'What is Generative AI? (जनरेटिव्ह AI म्हणजे काय?)',
      'How to communicate with AI - Prompting (AI शी संवाद कसा साधावा - प्रॉम्प्टिंग)',
      'Good vs Bad Prompts (चांगले vs वाईट प्रॉम्प्ट)',
      'Hands-on practice with AI tools (AI साधनांचा प्रत्यक्ष सराव)',
    ],
  },
  {
    id: 33,
    type: 'content',
    module: 5,
    title: 'The Magic Tool: Generative AI',
    marathi: 'जादुई साधन: जनरेटिव्ह AI',
    content: 'Imagine a magical assistant at your desk - ask it to write a 2-page speech on water conservation... and it writes a completely NEW, UNIQUE speech in seconds! (तुमच्या डेस्कवर एक जादुई सहाय्यक कल्पना करा - त्याला जलसंधारणावर २ पानांचे भाषण लिहायला सांगा... आणि तो काही सेकंदात एक पूर्णपणे नवीन, अद्वितीय भाषण लिहितो!)',
    bullets: [
      'Text: Emails, Reports, Speeches, Summaries, Translations (मजकूर: ईमेल, अहवाल, भाषणे, सारांश, भाषांतरे)',
      'Images: Designs, Diagrams, Charts, Infographics (प्रतिमा: डिझाइन्स, आकृत्या, तक्ते, इन्फोग्राफिक्स)',
      'Presentations: Slide decks, Training materials (सादरीकरण: स्लाइड डेक्स, प्रशिक्षण साहित्य)',
      'Analysis: Data insights, Trend reports, Comparisons (विश्लेषण: डेटा अंतर्दृष्टी, ट्रेंड अहवाल, तुलना)',
    ],
    tools: [
      { name: 'ChatGPT', desc: 'By OpenAI - Best for text, analysis, coding (OpenAI द्वारे - मजकूर, विश्लेषण, कोडिंगसाठी सर्वोत्तम)' },
      { name: 'Microsoft Copilot', desc: 'Integrated with Office 365 - Best for document work (Office 365 सह एकत्रित - दस्तऐवज कामासाठी सर्वोत्तम)' },
      { name: 'Google Gemini', desc: 'By Google - Best for search and research (Google द्वारे - शोध आणि संशोधनासाठी सर्वोत्तम)' },
    ],
    keyTakeaway: 'Generative AI creates NEW content based on what it has learned - it does not just copy-paste from the internet. (जनरेटिव्ह AI ने शिकलेल्या गोष्टींवर आधारित नवीन सामग्री तयार करते - ते इंटरनेटवरून कॉपी-पेस्ट करत नाही.)',
  },
  {
    id: 34,
    type: 'content',
    module: 5,
    title: 'What Can Generative AI Do For You?',
    marathi: 'जनरेटिव्ह AI तुमच्यासाठी काय करू शकते?',
    content: 'Practical uses for Maharashtra State Government officers: (महाराष्ट्र शासनाच्या अधिकाऱ्यांसाठी व्यावहारिक उपयोग:)',
    bullets: [
      'Draft official circulars and office orders in minutes (काही मिनिटांत अधिकृत परिपत्रके आणि कार्यालय आदेश तयार करा)',
      'Summarize 100-page policy documents into 1-page briefs (१०० पानांचे धोरण दस्तऐवज १ पानाच्या सारांशात रूपांतरित करा)',
      'Translate documents between English, Hindi, and Marathi (इंग्रजी, हिंदी आणि मराठी मध्ये दस्तऐवजांचे भाषांतर करा)',
      'Analyze budget data and create visual reports (अर्थसंकल्प डेटाचे विश्लेषण करा आणि दृश्य अहवाल तयार करा)',
      'Generate talking points for meetings and presentations (बैठकी आणि सादरीकरणांसाठी चर्चा बिंदू तयार करा)',
      'Create training materials for staff capacity building (कर्मचारी क्षमता निर्माणासाठी प्रशिक्षण साहित्य तयार करा)',
      'Draft replies to RTI applications and public queries (RTI अर्ज आणि सार्वजनिक चौकशींना उत्तरे तयार करा)',
    ],
  },
  {
    id: 35,
    type: 'quiz',
    module: 5,
    title: 'True or False: Generative AI',
    marathi: 'खरे की खोटे: जनरेटिव्ह AI',
    trueFalse: [
      {
        statement: 'Generative AI can draft an official email for you (जनरेटिव्ह AI तुमच्यासाठी अधिकृत ईमेल तयार करू शकते)',
        answer: true,
        explanation: 'TRUE - GenAI can draft professional emails that you can review and send. (खरे - GenAI व्यावसायिक ईमेल तयार करू शकते जे तुम्ही तपासून पाठवू शकता.)',
      },
      {
        statement: 'Generative AI only copies and pastes from Wikipedia (जनरेटिव्ह AI फक्त Wikipedia वरून कॉपी-पेस्ट करते)',
        answer: false,
        explanation: 'FALSE - GenAI creates original text based on patterns it learned, not by copying. (खोटे - GenAI ने शिकलेल्या नमुन्यांवर आधारित मूळ मजकूर तयार करते, कॉपी करून नाही.)',
      },
      {
        statement: 'GenAI cannot understand Marathi or Hindi (GenAI मराठी किंवा हिंदी समजू शकत नाही)',
        answer: false,
        explanation: 'FALSE - Modern GenAI tools like ChatGPT and Gemini work quite well with Indian languages! (खोटे - ChatGPT आणि Gemini सारखी आधुनिक GenAI साधने भारतीय भाषांमध्ये चांगले काम करतात!)',
      },
      {
        statement: 'You should always verify GenAI output before using officially (अधिकृत वापरापूर्वी तुम्ही नेहमी GenAI चे आउटपुट तपासले पाहिजे)',
        answer: true,
        explanation: 'TRUE - AI can make mistakes. Always review before official use. (खरे - AI चुका करू शकते. अधिकृत वापरापूर्वी नेहमी तपासा.)',
      },
    ],
  },
  {
    id: 36,
    type: 'content',
    module: 5,
    title: 'How to Talk to AI: Prompts',
    marathi: 'AI शी कसे बोलावे: प्रॉम्प्ट्स',
    content: 'AI is smart, but it needs CLEAR instructions. The instruction you type into AI is called a PROMPT. (AI हुशार आहे, पण त्याला स्पष्ट सूचना लागतात. तुम्ही AI मध्ये टाइप केलेल्या सूचनेला प्रॉम्प्ट म्हणतात.)',
    bullets: [
      'PROMPT (प्रॉम्प्ट): The instruction or question you type into the AI (तुम्ही AI मध्ये टाइप केलेली सूचना किंवा प्रश्न)',
      'RESPONSE (प्रतिसाद): What the AI generates based on your prompt (तुमच्या प्रॉम्प्टवर आधारित AI जे तयार करते)',
      'FOLLOW-UP PROMPT (फॉलो-अप प्रॉम्प्ट): How you refine the answer - "Make it shorter", "Translate to Marathi", "Add more details" (उत्तर कसे सुधारावे - "लहान करा", "मराठीत भाषांतर करा", "अधिक तपशील जोडा")',
    ],
    keyTakeaway: 'Think of AI as a very capable Personal Secretary (PA) waiting for your clear instructions! (AI ला तुमच्या स्पष्ट सूचनांची वाट पाहणारा एक अत्यंत सक्षम वैयक्तिक सचिव (PA) समजा!)',
  },
  {
    id: 37,
    type: 'content',
    module: 5,
    title: 'Good Prompts vs Bad Prompts: Everyday Example',
    marathi: 'चांगले प्रॉम्प्ट vs वाईट प्रॉम्प्ट: दैनंदिन उदाहरण',
    comparison: {
      left: {
        title: 'Bad Prompt (वाईट प्रॉम्प्ट)',
        items: [
          '"Tell me how to cook." ("मला स्वयंपाक कसा करायचा सांगा.")',
          'Too vague! (खूप अस्पष्ट!)',
          'Cook what? For how many? (काय शिजवायचे? किती जणांसाठी?)',
          'In what style? (कोणत्या शैलीत?)',
          'AI will give a generic answer (AI एक सामान्य उत्तर देईल)',
        ],
      },
      right: {
        title: 'Good Prompt (चांगला प्रॉम्प्ट)',
        items: [
          '"Share an easy recipe for Pav Bhaji for 4 people, including ingredients and cooking time." ("४ लोकांसाठी पाव भाजीची सोपी रेसिपी सांगा, साहित्य आणि वेळ सहित.")',
          'Specific dish! (विशिष्ट पदार्थ!)',
          'Clear quantity! (स्पष्ट प्रमाण!)',
          'Defined format! (निश्चित स्वरूप!)',
          'AI gives a detailed, useful answer (AI तपशीलवार, उपयुक्त उत्तर देतो)',
        ],
      },
    },
    keyTakeaway: 'The more SPECIFIC your prompt, the better the result! Just like giving clear orders to your staff. (तुमचा प्रॉम्प्ट जितका अधिक विशिष्ट, तितका चांगला परिणाम! तुमच्या कर्मचाऱ्यांना स्पष्ट आदेश देण्यासारखेच.)',
  },
  {
    id: 38,
    type: 'content',
    module: 5,
    title: 'Government Scenario: Good vs Bad Prompt',
    marathi: 'शासकीय परिस्थिती: चांगला vs वाईट प्रॉम्प्ट',
    comparison: {
      left: {
        title: 'Bad Prompt (वाईट प्रॉम्प्ट)',
        items: [
          '"Write a circular about office timings." ("कार्यालय वेळेबद्दल परिपत्रक लिहा.")',
          'What change? When does it start? (कोणता बदल? कधीपासून सुरू?)',
          'For whom? What department? (कोणासाठी? कोणता विभाग?)',
          'What tone? Formal or informal? (कोणता सूर? औपचारिक की अनौपचारिक?)',
          'Result: Generic, unusable circular (परिणाम: सामान्य, अनुपयोगी परिपत्रक)',
        ],
      },
      right: {
        title: 'Good Prompt (चांगला प्रॉम्प्ट)',
        items: [
          '"Draft a formal government circular informing all department staff that office timings will change to 9:30 AM - 5:30 PM starting next Monday. Keep the tone professional and concise." ("सर्व विभागीय कर्मचाऱ्यांना पुढील सोमवारपासून कार्यालय वेळ ९:३० AM - ५:३० PM बदलत असल्याची माहिती देणारे औपचारिक शासकीय परिपत्रक तयार करा. सूर व्यावसायिक आणि संक्षिप्त ठेवा.")',
          'Specific context! (विशिष्ट संदर्भ!)',
          'Clear audience! (स्पष्ट श्रोते!)',
          'Timeline defined! (कालमर्यादा निश्चित!)',
          'Tone specified! (सूर निर्दिष्ट!)',
        ],
      },
    },
    keyTakeaway: 'A good prompt has: Context + Audience + Specifics + Tone = Great Result (चांगल्या प्रॉम्प्टमध्ये: संदर्भ + श्रोते + तपशील + सूर = उत्कृष्ट परिणाम)',
  },
  {
    id: 39,
    type: 'activity',
    module: 5,
    title: 'Activity: Critique the Prompt',
    marathi: 'कृती: प्रॉम्प्टचे मूल्यांकन करा',
    content: 'Evaluate this prompt and improve it: (या प्रॉम्प्टचे मूल्यांकन करा आणि सुधारा:)',
    promptToEvaluate: '"Explain the new urban development policy." ("नवीन नगर विकास धोरण समजावून सांगा.")',
    instructions: [
      'Is this a good or bad prompt? Why? (हा चांगला की वाईट प्रॉम्प्ट आहे? का?)',
      'What information is missing? (कोणती माहिती गहाळ आहे?)',
      'How would you improve it? (तुम्ही ते कसे सुधाराल?)',
      'Discuss with your group for 2 minutes (तुमच्या गटासोबत २ मिनिटे चर्चा करा)',
    ],
    improvedVersion: '"Summarize the key points of the 2024 Maharashtra Urban Development Policy in 5 simple bullet points suitable for a public presentation to gram panchayat members." ("२०२४ च्या महाराष्ट्र नगर विकास धोरणाचे मुख्य मुद्दे ग्रामपंचायत सदस्यांसमोर सार्वजनिक सादरीकरणासाठी योग्य अशा ५ सोप्या बुलेट पॉइंट्समध्ये सारांशित करा.")',
    duration: '3 Minutes (३ मिनिटे)',
    format: 'Group Discussion (समूह चर्चा)',
  },
  {
    id: 40,
    type: 'content',
    module: 5,
    title: 'The CLEAR Prompt Framework',
    marathi: 'CLEAR प्रॉम्प्ट फ्रेमवर्क',
    content: 'Use this framework to write perfect prompts every time: (दरवेळी परिपूर्ण प्रॉम्प्ट लिहिण्यासाठी हे फ्रेमवर्क वापरा:)',
    framework: [
      { letter: 'C', word: 'Context (संदर्भ)', desc: 'Set the background - "I am a District Collector in Maharashtra..." (पार्श्वभूमी सेट करा - "मी महाराष्ट्रातील जिल्हाधिकारी आहे...")', marathi: 'संदर्भ' },
      { letter: 'L', word: 'Language (भाषा)', desc: 'Specify language and tone - "In formal English / Marathi" (भाषा आणि सूर निर्दिष्ट करा - "औपचारिक इंग्रजी / मराठीत")', marathi: 'भाषा' },
      { letter: 'E', word: 'Expectation (अपेक्षा)', desc: 'What you want - "Summarize in 5 bullet points" (तुम्हाला काय हवे - "५ बुलेट पॉइंट्समध्ये सारांश करा")', marathi: 'अपेक्षा' },
      { letter: 'A', word: 'Audience (श्रोते)', desc: 'Who will read it - "For village-level officers" (कोण वाचणार - "गाव पातळीच्या अधिकाऱ्यांसाठी")', marathi: 'श्रोते' },
      { letter: 'R', word: 'Refinement (सुधारणा)', desc: 'Follow-up to improve - "Make it simpler / shorter" (सुधारण्यासाठी फॉलो-अप - "सोपे / लहान करा")', marathi: 'सुधारणा' },
    ],
  },
  {
    id: 41,
    type: 'content',
    module: 5,
    title: 'Advanced Prompting Tips',
    marathi: 'प्रगत प्रॉम्प्टिंग टिप्स',
    bullets: [
      'Role Assignment: "Act as a senior IAS officer and review this draft..." (भूमिका देणे: "वरिष्ठ IAS अधिकारी म्हणून काम करा आणि हा मसुदा तपासा...")',
      'Step-by-Step: "Explain this in 3 simple steps..." (चरण-दर-चरण: "हे ३ सोप्या टप्प्यांत समजावून सांगा...")',
      'Format Control: "Present this as a table / bullet points / numbered list" (स्वरूप नियंत्रण: "हे तक्ता / बुलेट पॉइंट्स / क्रमांकित यादी म्हणून सादर करा")',
      'Examples: "Give me 5 examples relevant to district administration" (उदाहरणे: "जिल्हा प्रशासनाशी संबंधित ५ उदाहरणे द्या")',
      'Constraints: "Keep it under 200 words in formal Hindi" (मर्यादा: "औपचारिक हिंदीत २०० शब्दांच्या आत ठेवा")',
      'Chain Prompting: Ask follow-up questions to dig deeper into any topic (चेन प्रॉम्प्टिंग: कोणत्याही विषयात खोलवर जाण्यासाठी फॉलो-अप प्रश्न विचारा)',
    ],
    keyTakeaway: 'The better your instructions, the better AI performs. Practice makes perfect! (तुमच्या सूचना जितक्या चांगल्या, तितके AI चांगले काम करते. सरावाने परिपूर्णता येते!)',
  },
  {
    id: 42,
    type: 'activity',
    module: 5,
    title: 'Hands-On Group Activity',
    marathi: 'प्रत्यक्ष समूह कृती',
    content: 'Time to practice! Use AI tools on your phone or laptop. (सराव करण्याची वेळ! तुमच्या फोन किंवा लॅपटॉपवर AI साधने वापरा.)',
    instructions: [
      'Open ChatGPT, Gemini, or Microsoft Copilot on your phone/laptop (तुमच्या फोन/लॅपटॉपवर ChatGPT, Gemini किंवा Microsoft Copilot उघडा)',
      'Write a prompt to generate a welcome speech for a local cultural festival in your district (तुमच्या जिल्ह्यातील स्थानिक सांस्कृतिक महोत्सवासाठी स्वागत भाषण तयार करण्यासाठी प्रॉम्प्ट लिहा)',
      'Use a follow-up prompt: "Now make the speech shorter and add a Marathi greeting at the beginning" (फॉलो-अप प्रॉम्प्ट वापरा: "आता भाषण लहान करा आणि सुरुवातीला मराठी अभिवादन जोडा")',
      'Try one more: "Draft an official memo about implementing a new digital filing system in my office" (आणखी एक प्रयत्न करा: "माझ्या कार्यालयात नवीन डिजिटल फाइलिंग प्रणाली लागू करण्याबद्दल अधिकृत निवेदन तयार करा")',
    ],
    duration: '15 Minutes (१५ मिनिटे)',
    format: 'Work in Pairs (जोडीने काम करा)',
    facilitatorTip: 'Walk around and help participants who may be unfamiliar with the tools. Encourage experimentation! (फिरून साधनांशी अपरिचित असलेल्या सहभागींना मदत करा. प्रयोग करण्यास प्रोत्साहित करा!)',
  },
  {
    id: 43,
    type: 'timer',
    module: 5,
    title: 'Hands-On Activity Timer',
    marathi: 'प्रत्यक्ष कृती वेळ',
    minutes: 15,
    label: 'Hands-On Group Activity: Write prompts and experiment with AI tools (प्रत्यक्ष समूह कृती: प्रॉम्प्ट लिहा आणि AI साधनांचा प्रयोग करा)',
  },
  {
    id: 44,
    type: 'activity',
    module: 5,
    title: 'Share Your Best Prompts',
    marathi: 'तुमचे सर्वोत्तम प्रॉम्प्ट सामायिक करा',
    content: 'Each pair shares their best prompt and the AI response they got. (प्रत्येक जोडी त्यांचा सर्वोत्तम प्रॉम्प्ट आणि मिळालेला AI प्रतिसाद सामायिक करतो.)',
    instructions: [
      'Each pair presents their best prompt - 30 seconds each (प्रत्येक जोडी त्यांचा सर्वोत्तम प्रॉम्प्ट सादर करतो - प्रत्येकी ३० सेकंद)',
      'Show the AI response on screen if possible (शक्य असल्यास AI प्रतिसाद स्क्रीनवर दाखवा)',
      'Group votes on the most creative / useful prompt (सर्वात सर्जनशील / उपयुक्त प्रॉम्प्टसाठी गट मतदान करतो)',
      'Facilitator highlights best practices from the examples (सूत्रसंचालक उदाहरणांमधून सर्वोत्तम पद्धती अधोरेखित करतो)',
    ],
    duration: '5 Minutes (५ मिनिटे)',
    format: 'Group Sharing (समूह सामायिकरण)',
  },
  {
    id: 45,
    type: 'content',
    module: 5,
    title: 'Prompt Cheat Sheet for Government Officers',
    marathi: 'शासकीय अधिकाऱ्यांसाठी प्रॉम्प्ट चीट शीट',
    bullets: [
      'Drafting: "Draft a formal letter to [recipient] regarding [topic] in [language]. Keep the tone [professional/urgent]." (मसुदा तयार करणे: "[प्राप्तकर्त्याला] [विषय] बद्दल [भाषेत] औपचारिक पत्र तयार करा. सूर [व्यावसायिक/तातडीचा] ठेवा.")',
      'Summarizing: "Summarize this [document type] in [X] bullet points for [audience]." (सारांश: "हा [दस्तऐवज प्रकार] [श्रोत्यां]साठी [X] बुलेट पॉइंट्समध्ये सारांशित करा.")',
      'Translation: "Translate the following [language] text into formal [target language] suitable for a government gazette." (भाषांतर: "खालील [भाषा] मजकूर शासकीय राजपत्रासाठी योग्य अशा औपचारिक [लक्ष्य भाषेत] अनुवादित करा.")',
      'Analysis: "Analyze the following data and highlight the top 3 trends relevant to [department]." (विश्लेषण: "खालील डेटाचे विश्लेषण करा आणि [विभाग]ाशी संबंधित शीर्ष ३ ट्रेंड अधोरेखित करा.")',
      'Brainstorming: "Suggest 5 practical ways AI can improve [department name] efficiency in Maharashtra." (विचारमंथन: "महाराष्ट्रात [विभागाचे नाव] कार्यक्षमता AI सुधारू शकेल अशा ५ व्यावहारिक मार्गांची सूचना करा.")',
      'Review: "Review this draft for grammar, tone, and clarity. Make it professional and suitable for [purpose]." (पुनरावलोकन: "हा मसुदा व्याकरण, सूर आणि स्पष्टतेसाठी तपासा. [उद्देश]ासाठी व्यावसायिक आणि योग्य बनवा.")',
    ],
    keyTakeaway: 'Save this cheat sheet! Use it as your go-to reference when working with AI tools. (ही चीट शीट जतन करा! AI साधनांसह काम करताना संदर्भ म्हणून वापरा.)',
  },

  // ====== LUNCH BREAK (Slide 46) ======
  {
    id: 46,
    type: 'break',
    module: 0,
    title: 'Lunch Break',
    marathi: 'दुपारच्या जेवणाची विश्रांती',
    duration: '45 Minutes (४५ मिनिटे)',
    message: 'Enjoy your meal! After lunch, we explore how AI impacts your work and departments. (जेवणाचा आनंद घ्या! जेवणानंतर, AI तुमच्या कामावर आणि विभागांवर कसा परिणाम करते ते शोधू.)',
    funFact: 'Fun Fact: AI can analyze the nutritional content of your lunch from just a photo! Apps like MyFitnessPal use AI for food recognition. (मजेशीर सत्य: AI फक्त फोटोवरून तुमच्या जेवणातील पोषणमूल्यांचे विश्लेषण करू शकते! MyFitnessPal सारखी ॲप्स अन्न ओळखण्यासाठी AI वापरतात.)',
  },

  // ====== MODULE 6: AI IMPACT ON WORKFORCE (Slides 47-54) ======
  {
    id: 47,
    type: 'section',
    module: 6,
    title: 'Impact of AI on Jobs & Administration',
    marathi: 'नोकऱ्या आणि प्रशासनावर AI चा प्रभाव',
    moduleNumber: 'Module 5 (मॉड्यूल ५)',
    learningObjectives: [
      'How AI is changing the workplace (AI कार्यस्थळ कसे बदलत आहे)',
      'Advantages and disadvantages of AI at work (कामावर AI चे फायदे आणि तोटे)',
      'Impact on government administration (शासकीय प्रशासनावर प्रभाव)',
    ],
  },
  {
    id: 48,
    type: 'content',
    module: 6,
    title: 'The Rise of AI in the Workplace',
    marathi: 'कार्यस्थळावर AI चा उदय',
    comparison: {
      left: {
        title: 'Private Sector Examples (खाजगी क्षेत्र उदाहरणे)',
        items: [
          'Amazon Go stores - no cashiers needed (Amazon Go दुकाने - कॅशियरची गरज नाही)',
          'Banks - AI chatbots handle customer queries (बँका - AI चॅटबॉट्स ग्राहक चौकशी हाताळतात)',
          'Hospitals - AI reads X-rays and MRI scans (रुग्णालये - AI एक्स-रे आणि MRI स्कॅन वाचते)',
          'Factories - Robots assemble products (कारखाने - रोबोट उत्पादने जोडतात)',
          'IT companies - AI writes and reviews code (IT कंपन्या - AI कोड लिहिते आणि तपासते)',
        ],
      },
      right: {
        title: 'Public Sector Examples (सार्वजनिक क्षेत्र उदाहरणे)',
        items: [
          'FASTag - automated toll collection (FASTag - स्वयंचलित टोल संकलन)',
          'AI traffic management in smart cities (स्मार्ट शहरांमध्ये AI वाहतूक व्यवस्थापन)',
          'Citizen portal chatbots - 24/7 support (नागरिक पोर्टल चॅटबॉट्स - २४/७ सहाय्य)',
          'AI-powered crop insurance claims processing (AI-आधारित पीक विमा दावा प्रक्रिया)',
          'Digital court case management systems (डिजिटल न्यायालय प्रकरण व्यवस्थापन प्रणाली)',
        ],
      },
    },
  },
  {
    id: 49,
    type: 'content',
    module: 6,
    title: 'AI in Indian Government: Real Case Studies',
    marathi: 'भारतीय शासनात AI: वास्तविक केस स्टडी',
    bullets: [
      'MyGov Chatbot: Answers citizen queries 24/7 in multiple Indian languages (MyGov चॅटबॉट: अनेक भारतीय भाषांमध्ये २४/७ नागरिक चौकशींना उत्तरे देतो)',
      'AI in Agriculture: IFFCO uses AI for soil analysis and crop prediction (कृषीतील AI: IFFCO मृदा विश्लेषण आणि पीक अंदाजासाठी AI वापरतो)',
      'Smart Policing: Delhi Police uses AI-based facial recognition for crowd management (स्मार्ट पोलिसिंग: दिल्ली पोलीस गर्दी व्यवस्थापनासाठी AI-आधारित चेहरा ओळख वापरतात)',
      'Healthcare: AI screens for tuberculosis in govt hospitals using X-ray analysis (आरोग्य: सरकारी रुग्णालयांमध्ये एक्स-रे विश्लेषण वापरून AI क्षयरोगाची तपासणी करते)',
      'Tax Collection: GST analytics use AI to detect tax evasion patterns (कर संकलन: GST विश्लेषण कर चोरीचे नमुने शोधण्यासाठी AI वापरते)',
      'DigiYatra: AI-based facial recognition for seamless airport check-in (DigiYatra: सुलभ विमानतळ चेक-इनसाठी AI-आधारित चेहरा ओळख)',
    ],
    keyTakeaway: 'AI is not replacing government officers. It is becoming their most powerful tool for better governance. (AI शासकीय अधिकाऱ्यांची जागा घेत नाही. ते चांगल्या शासनासाठी त्यांचे सर्वात शक्तिशाली साधन बनत आहे.)',
  },
  {
    id: 50,
    type: 'activity',
    module: 6,
    title: 'Discussion: AI in Your Department',
    marathi: 'चर्चा: तुमच्या विभागात AI',
    content: 'Think about YOUR specific department and daily work: (तुमच्या विशिष्ट विभागाबद्दल आणि दैनंदिन कामाबद्दल विचार करा:)',
    instructions: [
      'What routine, repetitive tasks in your office could AI handle? (तुमच्या कार्यालयातील कोणती नियमित, पुनरावृत्ती होणारी कामे AI हाताळू शकते?)',
      'Examples: Sorting grievance emails, Data entry, Scheduling, Report generation (उदाहरणे: तक्रार ईमेल वर्गीकरण, डेटा एंट्री, वेळापत्रक, अहवाल तयार करणे)',
      'How would this change the daily work of your staff? (यामुळे तुमच्या कर्मचाऱ्यांच्या दैनंदिन कामात कसा बदल होईल?)',
      'Share your best idea with the group (तुमची सर्वोत्तम कल्पना गटासोबत सामायिक करा)',
    ],
    duration: '3 Minutes (३ मिनिटे)',
    format: 'Think & Discuss (विचार करा आणि चर्चा करा)',
    facilitatorTip: 'Encourage officers from different departments (Revenue, Health, Education, Agriculture) to share diverse perspectives. (विविध विभागांमधील अधिकाऱ्यांना (महसूल, आरोग्य, शिक्षण, कृषी) विविध दृष्टिकोन सामायिक करण्यास प्रोत्साहित करा.)',
  },
  {
    id: 51,
    type: 'content',
    module: 6,
    title: 'Advantages of AI in Government',
    marathi: 'शासनात AI चे फायदे',
    bullets: [
      'SPEED (वेग): Takes over repetitive clerical tasks instantly - file sorting, data entry, form processing (पुनरावृत्ती होणारी लिपिक कामे तात्काळ करते - फाइल वर्गीकरण, डेटा एंट्री, फॉर्म प्रक्रिया)',
      'ANALYSIS (विश्लेषण): Analyzes massive datasets like census, budget, health data in seconds (जनगणना, अर्थसंकल्प, आरोग्य डेटा यासारख्या प्रचंड डेटाचे सेकंदांत विश्लेषण करते)',
      'AVAILABILITY (उपलब्धता): Works 24/7 without getting tired - citizen chatbots, grievance tracking (थकल्याशिवाय २४/७ काम करते - नागरिक चॅटबॉट्स, तक्रार ट्रॅकिंग)',
      'DECISION SUPPORT (निर्णय सहाय्य): Provides data-driven insights for better policy decisions (चांगल्या धोरण निर्णयांसाठी डेटा-आधारित अंतर्दृष्टी प्रदान करते)',
      'CITIZEN SERVICE (नागरिक सेवा): Faster response to citizen queries and complaints (नागरिक चौकशी आणि तक्रारींना जलद प्रतिसाद)',
      'COST SAVINGS (खर्च बचत): Reduces processing time and manual errors in government operations (शासकीय कामकाजात प्रक्रिया वेळ आणि मानवी चुका कमी करते)',
    ],
  },
  {
    id: 52,
    type: 'content',
    module: 6,
    title: 'Disadvantages & Risks of AI',
    marathi: 'AI चे तोटे आणि जोखीम',
    bullets: [
      'COST (खर्च): Implementation can be expensive at state-wide level (राज्यव्यापी पातळीवर अंमलबजावणी महाग असू शकते)',
      'TRAINING (प्रशिक्षण): Requires significant upskilling of existing staff (विद्यमान कर्मचाऱ्यांचे लक्षणीय कौशल्य वर्धन आवश्यक)',
      'ERRORS (चुका): Can "hallucinate" - make up facts if not monitored by humans (माणसांनी निरीक्षण न केल्यास "भ्रमित" होऊ शकते - तथ्ये तयार करू शकते)',
      'JOB CONCERNS (नोकरी चिंता): Some clerical roles may need to evolve (काही लिपिक भूमिकांना विकसित होणे आवश्यक असू शकते)',
      'DATA SECURITY (डेटा सुरक्षा): Risk of sensitive citizen data being compromised (संवेदनशील नागरिक डेटा धोक्यात येण्याची शक्यता)',
      'DIGITAL DIVIDE (डिजिटल दरी): Not all citizens or officers have equal access to technology (सर्व नागरिक किंवा अधिकाऱ्यांना तंत्रज्ञानात समान प्रवेश नाही)',
    ],
    keyTakeaway: 'AI is a powerful tool, but it needs careful, responsible implementation with human oversight. (AI एक शक्तिशाली साधन आहे, पण त्यासाठी मानवी देखरेखीसह काळजीपूर्वक, जबाबदार अंमलबजावणी आवश्यक आहे.)',
  },
  {
    id: 53,
    type: 'quiz',
    module: 6,
    title: 'Assessment: Advantage or Disadvantage?',
    marathi: 'मूल्यांकन: फायदा की तोटा?',
    questions: [
      {
        question: 'AI can summarize a 100-page file in 10 seconds (AI १० सेकंदात १०० पानांच्या फाइलचा सारांश काढू शकते)',
        options: ['Advantage (फायदा)', 'Disadvantage (तोटा)'],
        correct: 0,
        explanation: 'Advantage! AI dramatically speeds up document processing. (फायदा! AI दस्तऐवज प्रक्रिया नाटकीयपणे गतिमान करते.)',
      },
      {
        question: 'AI might make a mistake if trained on outdated data (कालबाह्य डेटावर प्रशिक्षित केल्यास AI चूक करू शकते)',
        options: ['Advantage (फायदा)', 'Disadvantage (तोटा)'],
        correct: 1,
        explanation: 'Disadvantage - AI is only as good as its data. Outdated data leads to wrong decisions. (तोटा - AI फक्त त्याच्या डेटाइतकेच चांगले आहे. कालबाह्य डेटामुळे चुकीचे निर्णय होतात.)',
      },
      {
        question: 'AI takes over repetitive data entry tasks (AI पुनरावृत्ती होणारी डेटा एंट्री कामे घेते)',
        options: ['Advantage (फायदा)', 'Disadvantage (तोटा)'],
        correct: 0,
        explanation: 'Advantage! Staff are freed for higher-value work requiring human judgment. (फायदा! मानवी निर्णय आवश्यक असलेल्या उच्च-मूल्य कामासाठी कर्मचारी मुक्त होतात.)',
      },
      {
        question: 'Implementing AI requires significant budget and staff training (AI अंमलबजावणीसाठी मोठा अर्थसंकल्प आणि कर्मचारी प्रशिक्षण आवश्यक)',
        options: ['Advantage (फायदा)', 'Disadvantage (तोटा)'],
        correct: 1,
        explanation: 'Disadvantage - AI has upfront costs. But long-term benefits often outweigh costs. (तोटा - AI चा प्रारंभिक खर्च आहे. पण दीर्घकालीन फायदे सहसा खर्चापेक्षा जास्त असतात.)',
      },
    ],
  },
  {
    id: 54,
    type: 'activity',
    module: 6,
    title: 'Reflection: How Do You Feel About AI?',
    marathi: 'चिंतन: AI बद्दल तुम्हाला कसे वाटते?',
    content: 'Looking at these changes, which word best describes your feeling? (हे बदल पाहून, तुमच्या भावनेचे सर्वोत्तम वर्णन कोणता शब्द करतो?)',
    feelings: ['Excited (उत्साहित)', 'Curious (उत्सुक)', 'Worried (चिंतित)', 'Inspired (प्रेरित)', 'Cautious (सावध)'],
    keyTakeaway: 'All feelings are valid! Change can be daunting, but managing it effectively is leadership. You are here to lead this change. (सर्व भावना वैध आहेत! बदल भयावह असू शकतो, पण तो प्रभावीपणे व्यवस्थापित करणे म्हणजे नेतृत्व. तुम्ही या बदलाचे नेतृत्व करण्यासाठी येथे आहात.)',
  },

  // ====== MODULE 7: AI IN YOUR DEPARTMENT (Slides 55-62) ======
  {
    id: 55,
    type: 'section',
    module: 7,
    title: 'AI in Departmental Work',
    marathi: 'विभागीय कामात AI',
    moduleNumber: 'Module 6 (मॉड्यूल ६)',
    learningObjectives: [
      'Practical ways to use AI for your government role (तुमच्या शासकीय भूमिकेसाठी AI वापरण्याचे व्यावहारिक मार्ग)',
      'Case studies: Public Grievances and Agriculture (केस स्टडी: नागरिक तक्रारी आणि कृषी)',
      'Creating your personal AI action plan (तुमची वैयक्तिक AI कृती योजना तयार करणे)',
    ],
  },
  {
    id: 56,
    type: 'content',
    module: 7,
    title: 'Identifying AI Opportunities',
    marathi: 'AI संधी ओळखणे',
    content: 'AI is NOT here to replace senior decision-makers. AI IS here to act as your executive assistant. (AI वरिष्ठ निर्णयकर्त्यांची जागा घेण्यासाठी आलेले नाही. AI तुमच्या कार्यकारी सहाय्यक म्हणून काम करण्यासाठी आले आहे.)',
    comparison: {
      left: {
        title: 'AI is NOT here to... (AI यासाठी नाही...)',
        items: [
          'Replace senior decision-makers (वरिष्ठ निर्णयकर्त्यांची जागा घेणे)',
          'Take over human judgment (मानवी निर्णयक्षमता ताब्यात घेणे)',
          'Make policy without oversight (देखरेखीशिवाय धोरण बनवणे)',
          'Remove the need for officers (अधिकाऱ्यांची गरज संपवणे)',
        ],
      },
      right: {
        title: 'AI IS here to... (AI यासाठी आहे...)',
        items: [
          'Act as your executive assistant (तुमचा कार्यकारी सहाय्यक म्हणून काम करणे)',
          'Handle repetitive tasks efficiently (पुनरावृत्ती कामे कार्यक्षमतेने हाताळणे)',
          'Support data-driven decisions (डेटा-आधारित निर्णयांना सहाय्य करणे)',
          'Free your time for leadership (नेतृत्वासाठी तुमचा वेळ मोकळा करणे)',
        ],
      },
    },
    keyTakeaway: 'YOU remain in CONTROL. You make the FINAL DECISIONS. AI supports you. (तुम्ही नियंत्रणात राहता. तुम्ही अंतिम निर्णय घेता. AI तुम्हाला सहाय्य करते.)',
  },
  {
    id: 57,
    type: 'activity',
    module: 7,
    title: 'Live Prompting Exercise: Your Department',
    marathi: 'प्रत्यक्ष प्रॉम्प्टिंग सराव: तुमचा विभाग',
    content: 'Open ChatGPT / Gemini / Copilot and type this prompt (customize for your department): (ChatGPT / Gemini / Copilot उघडा आणि हा प्रॉम्प्ट टाइप करा (तुमच्या विभागासाठी सानुकूलित करा):)',
    promptTemplate: '"I am a senior government official in the [Your Department] department in Maharashtra. Can you suggest 5 practical ways AI tools could help my department operate more efficiently?" ("मी महाराष्ट्रातील [तुमचा विभाग] विभागातील वरिष्ठ शासकीय अधिकारी आहे. AI साधने माझ्या विभागाला अधिक कार्यक्षमतेने काम करण्यास कशी मदत करू शकतात याचे ५ व्यावहारिक मार्ग सुचवू शकता का?")',
    instructions: [
      'Type this prompt, customize for YOUR department (हा प्रॉम्प्ट टाइप करा, तुमच्या विभागासाठी सानुकूलित करा)',
      'Read the AI suggestions carefully (AI च्या सूचना काळजीपूर्वक वाचा)',
      'Pick the BEST idea that is most practical for your department (तुमच्या विभागासाठी सर्वात व्यावहारिक असलेली सर्वोत्तम कल्पना निवडा)',
      'Share it with the room (ती सर्वांसोबत सामायिक करा)',
    ],
    duration: '5 Minutes (५ मिनिटे)',
    format: 'Individual + Group Sharing (वैयक्तिक + समूह सामायिकरण)',
  },
  {
    id: 58,
    type: 'content',
    module: 7,
    title: 'Drilling Down with Follow-Up Prompts',
    marathi: 'फॉलो-अप प्रॉम्प्ट्सने खोलात जाणे',
    content: 'Once AI suggests ideas, dig deeper with follow-up prompts: (AI कल्पना सुचवल्यानंतर, फॉलो-अप प्रॉम्प्ट्सने खोलात जा:)',
    bullets: [
      'Prompt 1: "What are the common challenges in implementing [Idea] in a government setting?" (प्रॉम्प्ट १: "शासकीय वातावरणात [कल्पना] अंमलबजावणीतील सामान्य आव्हाने कोणती?")',
      'Prompt 2: "What basic skills would my staff need to learn to use this?" (प्रॉम्प्ट २: "हे वापरण्यासाठी माझ्या कर्मचाऱ्यांना कोणती मूलभूत कौशल्ये शिकावी लागतील?")',
      'Prompt 3: "Can you create a simple 3-month implementation roadmap?" (प्रॉम्प्ट ३: "तुम्ही एक सोपा ३ महिन्यांचा अंमलबजावणी रोडमॅप तयार करू शकता का?")',
      'Prompt 4: "What is the approximate cost and resources needed?" (प्रॉम्प्ट ४: "अंदाजे किती खर्च आणि संसाधने लागतील?")',
      'Prompt 5: "Show me examples of other Indian states that have done this successfully." (प्रॉम्प्ट ५: "हे यशस्वीपणे केलेल्या इतर भारतीय राज्यांची उदाहरणे दाखवा.")',
    ],
    keyTakeaway: 'Keep asking questions until you have actionable plans! AI never gets tired of your questions. (कृतीशील योजना तयार होईपर्यंत प्रश्न विचारत राहा! AI तुमच्या प्रश्नांमुळे कधीच थकत नाही.)',
  },
  {
    id: 59,
    type: 'content',
    module: 7,
    title: 'Case Study: Public Grievances',
    marathi: 'केस स्टडी: नागरिक तक्रारी',
    content: 'How AI can transform the public grievance process in Maharashtra: (AI महाराष्ट्रातील नागरिक तक्रार प्रक्रिया कशी बदलू शकते:)',
    comparison: {
      left: {
        title: 'Current State (सध्याची स्थिती)',
        items: [
          'Thousands of letters arrive daily (दररोज हजारो पत्रे येतात)',
          'Clerks manually read and categorize (लिपिक हाताने वाचतात आणि वर्गीकृत करतात)',
          'Route to appropriate desk manually (योग्य डेस्कवर हाताने पाठवतात)',
          'Takes several days to respond (प्रतिसाद देण्यास अनेक दिवस लागतात)',
          'No priority identification system (प्राधान्य ओळख प्रणाली नाही)',
        ],
      },
      right: {
        title: 'AI-Enabled State (AI-सक्षम स्थिती)',
        items: [
          'AI reads and classifies text instantly (AI तात्काळ मजकूर वाचते आणि वर्गीकृत करते)',
          'Auto-categorizes: Water, Roads, Electricity... (स्वयं-वर्गीकरण: पाणी, रस्ते, वीज...)',
          'Flags urgent complaints automatically (तातडीच्या तक्रारी आपोआप चिन्हांकित करते)',
          'Routes to correct desk instantly (योग्य डेस्कवर तात्काळ पाठवते)',
          'Priority scoring and tracking (प्राधान्य गुणांकन आणि ट्रॅकिंग)',
        ],
      },
    },
    impact: [
      'Faster citizen response time - days to hours (नागरिक प्रतिसाद वेळ जलद - दिवसांऐवजी तासांमध्ये)',
      'Clerks freed for higher-value work (लिपिक उच्च-मूल्य कामासाठी मुक्त)',
      'Better data for policy decisions (धोरण निर्णयांसाठी चांगला डेटा)',
      'Citizen satisfaction improvement (नागरिक समाधान सुधारणा)',
    ],
  },
  {
    id: 60,
    type: 'content',
    module: 7,
    title: 'Case Study: Agriculture & Revenue',
    marathi: 'केस स्टडी: कृषी आणि महसूल',
    content: 'AI applications in two key Maharashtra departments: (महाराष्ट्राच्या दोन प्रमुख विभागांमध्ये AI चे उपयोग:)',
    comparison: {
      left: {
        title: 'Agriculture (कृषी)',
        items: [
          'AI predicts crop yield using satellite data (AI उपग्रह डेटा वापरून पीक उत्पन्नाचा अंदाज लावते)',
          'Soil health analysis from sensor data (सेन्सर डेटावरून मृदा आरोग्य विश्लेषण)',
          'Early pest/disease detection from photos (फोटोंमधून कीड/रोगांचा लवकर शोध)',
          'Weather-based irrigation advisories (हवामान-आधारित सिंचन सल्ला)',
          'Automated crop insurance claim processing (स्वयंचलित पीक विमा दावा प्रक्रिया)',
        ],
      },
      right: {
        title: 'Revenue (महसूल)',
        items: [
          'Digital land record verification using AI (AI वापरून डिजिटल जमीन नोंद पडताळणी)',
          'Fraud detection in mutation applications (फेरफार अर्जांमध्ये फसवणूक शोध)',
          'Automated property valuation (स्वयंचलित मालमत्ता मूल्यांकन)',
          'Satellite-based encroachment detection (उपग्रह-आधारित अतिक्रमण शोध)',
          'Streamlined 7/12 extract processing (सुव्यवस्थित ७/१२ उतारा प्रक्रिया)',
        ],
      },
    },
    keyTakeaway: 'AI can save thousands of staff-hours across departments while improving accuracy and citizen service. (AI विभागांमध्ये हजारो कर्मचारी-तास वाचवू शकते आणि अचूकता व नागरिक सेवा सुधारू शकते.)',
  },
  {
    id: 61,
    type: 'activity',
    module: 7,
    title: 'Reflection Activity',
    marathi: 'चिंतन कृती',
    content: 'Write down your personal AI action plan: (तुमची वैयक्तिक AI कृती योजना लिहा:)',
    instructions: [
      'MY TASK: One task in your office you will simplify using AI next week (माझे कार्य: पुढच्या आठवड्यात AI वापरून तुम्ही सोपे कराल असे एक कार्य)',
      'AI TOOL I WILL USE: ChatGPT / Copilot / Gemini / Other (मी वापरणार असलेले AI साधन: ChatGPT / Copilot / Gemini / इतर)',
      'EXPECTED BENEFIT: Time saved, quality improved, citizen experience enhanced (अपेक्षित फायदा: वेळ वाचला, गुणवत्ता सुधारली, नागरिक अनुभव वाढला)',
      'FIRST STEP: What is the very first thing you will do on Monday? (पहिले पाऊल: सोमवारी तुम्ही सर्वप्रथम काय कराल?)',
    ],
    duration: '3 Minutes (३ मिनिटे)',
    format: 'Individual Writing (वैयक्तिक लेखन)',
    facilitatorTip: 'Encourage officers to start small. A single successful AI experiment builds confidence for bigger initiatives. (अधिकाऱ्यांना छोट्या गोष्टींपासून सुरुवात करण्यास प्रोत्साहित करा. एक यशस्वी AI प्रयोग मोठ्या उपक्रमांसाठी आत्मविश्वास निर्माण करतो.)',
  },
  {
    id: 62,
    type: 'content',
    module: 7,
    title: 'Your AI Action Plan Template',
    marathi: 'तुमचा AI कृती योजना टेम्पलेट',
    actionPlan: [
      { field: 'Department (विभाग)', placeholder: 'e.g., Revenue / Health / Education (उदा., महसूल / आरोग्य / शिक्षण)' },
      { field: 'Task to Automate (स्वयंचलित करायचे कार्य)', placeholder: 'e.g., Summarize weekly reports (उदा., साप्ताहिक अहवालांचा सारांश)' },
      { field: 'AI Tool (AI साधन)', placeholder: 'ChatGPT / Copilot / Gemini' },
      { field: 'Expected Time Saved (अपेक्षित वेळ बचत)', placeholder: 'e.g., 2 hours per week (उदा., दर आठवड्याला २ तास)' },
      { field: 'First Step (पहिले पाऊल)', placeholder: 'e.g., Try summarizing one document this Monday (उदा., या सोमवारी एका दस्तऐवजाचा सारांश काढून पहा)' },
      { field: 'Success Metric (यश मापदंड)', placeholder: 'e.g., Report ready 50% faster (उदा., अहवाल ५०% वेगाने तयार)' },
    ],
    keyTakeaway: 'Start small. Learn by doing. Build confidence one task at a time. (छोट्या गोष्टींपासून सुरुवात करा. करून शिका. एका वेळी एक कार्य करून आत्मविश्वास निर्माण करा.)',
  },

  // ====== MODULE 8: PROFESSIONAL DEVELOPMENT (Slides 63-66) ======
  {
    id: 63,
    type: 'section',
    module: 8,
    title: 'Professional Capacity Building',
    marathi: 'व्यावसायिक क्षमता निर्माण',
    moduleNumber: 'Module 7 (मॉड्यूल ७)',
    learningObjectives: [
      'How to use AI as your personal research assistant (AI तुमचा वैयक्तिक संशोधन सहाय्यक म्हणून कसे वापरावे)',
      'Prompting for complex topics and summarization (जटिल विषय आणि सारांशासाठी प्रॉम्प्टिंग)',
      'AI for translation and idea generation (भाषांतर आणि कल्पना निर्मितीसाठी AI)',
    ],
  },
  {
    id: 64,
    type: 'content',
    module: 8,
    title: 'AI as Your Research Assistant',
    marathi: 'तुमचा संशोधन सहाय्यक म्हणून AI',
    content: 'As senior officers, you constantly need to read regulations, study guidelines, research best practices, and analyze complex documents. AI can cut your reading time by 80%! (वरिष्ठ अधिकारी म्हणून, तुम्हाला सतत नियमावली वाचणे, मार्गदर्शक तत्त्वांचा अभ्यास करणे, सर्वोत्तम पद्धतींचे संशोधन करणे आणि जटिल दस्तऐवजांचे विश्लेषण करणे आवश्यक आहे. AI तुमचा वाचनाचा वेळ ८०% कमी करू शकते!)',
    bullets: [
      'SUMMARIZE: Condense 100-page reports into 1-page executive briefs (सारांश: १०० पानांचे अहवाल १ पानाच्या कार्यकारी सारांशात संक्षेपित करा)',
      'EXPLAIN: Break complex policies into simple language (स्पष्टीकरण: जटिल धोरणे सोप्या भाषेत विभागा)',
      'TRANSLATE: Convert documents between English, Hindi, and Marathi (भाषांतर: इंग्रजी, हिंदी आणि मराठी मध्ये दस्तऐवज रूपांतरित करा)',
      'EXTRACT: Pull key insights and action items from lengthy documents (मुख्य मुद्दे: दीर्घ दस्तऐवजांमधून मुख्य अंतर्दृष्टी आणि कृती मुद्दे काढा)',
      'COMPARE: Analyze differences between old and new policy versions (तुलना: जुन्या आणि नवीन धोरण आवृत्त्यांमधील फरकांचे विश्लेषण करा)',
      'RESEARCH: Find best practices from other states and countries (संशोधन: इतर राज्ये आणि देशांमधील सर्वोत्तम पद्धती शोधा)',
    ],
  },
  {
    id: 65,
    type: 'content',
    module: 8,
    title: 'Prompting for Complex Government Topics',
    marathi: 'जटिल शासकीय विषयांसाठी प्रॉम्प्टिंग',
    content: 'Example prompts for real government scenarios: (वास्तविक शासकीय परिस्थितींसाठी उदाहरण प्रॉम्प्ट:)',
    bullets: [
      '"I need to understand the new Digital Personal Data Protection Act. Explain the key highlights in simple terms, using examples relevant to a state government office." ("मला नवीन डिजिटल वैयक्तिक डेटा संरक्षण कायदा समजून घ्यायचा आहे. राज्य शासकीय कार्यालयाशी संबंधित उदाहरणे वापरून सोप्या शब्दांत मुख्य ठळक मुद्दे समजावून सांगा.")',
      '"I have a 40-page environmental impact report. Give me a 1-page executive summary highlighting the 3 main recommendations for state authorities." ("माझ्याकडे ४० पानांचा पर्यावरण प्रभाव अहवाल आहे. राज्य प्राधिकरणांसाठी ३ मुख्य शिफारसी अधोरेखित करणारा १ पानाचा कार्यकारी सारांश द्या.")',
      '"Compare the old and new Land Revenue Code provisions regarding online mutation. Present differences in a simple table." ("ऑनलाइन फेरफाराबद्दल जुन्या आणि नवीन जमीन महसूल कायद्याच्या तरतुदींची तुलना करा. फरक सोप्या तक्त्यात सादर करा.")',
      '"Explain the PM-KISAN scheme eligibility criteria in simple Marathi that I can share with talathi staff." ("PM-KISAN योजनेच्या पात्रता निकषांचे सोप्या मराठीत स्पष्टीकरण द्या जे मी तलाठी कर्मचाऱ्यांना सामायिक करू शकतो.")',
    ],
    keyTakeaway: 'AI is your tireless research assistant. Specify the topic, your level of understanding, and the format you need. (AI तुमचा अथक संशोधन सहाय्यक आहे. विषय, तुमच्या समजुतीची पातळी आणि तुम्हाला हवे असलेले स्वरूप निर्दिष्ट करा.)',
  },
  {
    id: 66,
    type: 'content',
    module: 8,
    title: 'AI for Translation & Creative Ideas',
    marathi: 'भाषांतर आणि सर्जनशील कल्पनांसाठी AI',
    content: 'Two more powerful uses of AI for government officers: (शासकीय अधिकाऱ्यांसाठी AI चे आणखी दोन शक्तिशाली उपयोग:)',
    translationExamples: [
      {
        title: 'Translation (भाषांतर)',
        prompt: '"Translate the following English policy paragraph into formal Marathi suitable for a government gazette." ("खालील इंग्रजी धोरण परिच्छेदाचे शासकीय राजपत्रासाठी योग्य अशा औपचारिक मराठीत भाषांतर करा.")',
        tip: 'AI handles English-Marathi translation well. Always review for formal government terminology. (AI इंग्रजी-मराठी भाषांतर चांगले हाताळते. औपचारिक शासकीय शब्दावलीसाठी नेहमी तपासा.)',
      },
      {
        title: 'Idea Generation (कल्पना निर्मिती)',
        prompt: '"We are launching a public health awareness campaign for dengue prevention in Pune. Suggest 5 catchy slogans, 3 community engagement ideas, and 2 social media post concepts." ("आम्ही पुण्यात डेंग्यू प्रतिबंधासाठी सार्वजनिक आरोग्य जागरूकता मोहीम सुरू करत आहोत. ५ आकर्षक घोषणा, ३ सामुदायिक सहभाग कल्पना आणि २ सोशल मीडिया पोस्ट संकल्पना सुचवा.")',
        tip: 'Use AI as your creative brainstorming partner. Get dozens of ideas in seconds, then refine the best ones. (AI ला तुमचा सर्जनशील विचारमंथन भागीदार म्हणून वापरा. सेकंदांत डझनभर कल्पना मिळवा, मग सर्वोत्तम निवडा.)',
      },
    ],
    keyTakeaway: 'AI is your multilingual, always-available editor and brainstorming partner. It never runs out of ideas! (AI तुमचा बहुभाषिक, नेहमी उपलब्ध संपादक आणि विचारमंथन भागीदार आहे. त्याच्या कल्पना कधीच संपत नाहीत!)',
  },

  // ====== MODULE 9: ETHICS & RESPONSIBLE AI (Slides 67-70) ======
  {
    id: 67,
    type: 'section',
    module: 9,
    title: 'Ethics & Responsible AI',
    marathi: 'नैतिकता आणि जबाबदार AI',
    moduleNumber: 'Module 8 (मॉड्यूल ८)',
    learningObjectives: [
      'What is Ethical AI? (नैतिक AI म्हणजे काय?)',
      'Challenges: Bias, Privacy, and Security (आव्हाने: पूर्वग्रह, गोपनीयता आणि सुरक्षा)',
      'The Human in the Loop rule (मानव नियंत्रणात ठेवण्याचा नियम)',
      'Ensuring responsible governance with AI (AI सह जबाबदार शासन सुनिश्चित करणे)',
    ],
  },
  {
    id: 68,
    type: 'content',
    module: 9,
    title: 'Ethical AI: Key Principles & Human in the Loop',
    marathi: 'नैतिक AI: मुख्य तत्त्वे आणि मानवी नियंत्रण',
    content: 'AI has immense power, but it must be used SAFELY and FAIRLY. As government officers, you have a special responsibility. (AI कडे अफाट शक्ती आहे, पण ते सुरक्षितपणे आणि न्याय्यपणे वापरले पाहिजे. शासकीय अधिकारी म्हणून, तुमची विशेष जबाबदारी आहे.)',
    bullets: [
      'TRANSPARENT (पारदर्शक): We understand how AI makes decisions (AI कसे निर्णय घेते हे आपण समजतो)',
      'UNBIASED (निष्पक्ष): Treats all citizens equally and fairly (सर्व नागरिकांशी समान आणि न्याय्य वागणूक)',
      'PRIVACY-PROTECTING (गोपनीयता रक्षण): Safeguards all sensitive citizen data (सर्व संवेदनशील नागरिक डेटाचे संरक्षण)',
      'ACCOUNTABLE (जबाबदार): Humans remain responsible for AI decisions (AI निर्णयांसाठी मानव जबाबदार राहतात)',
      'EXPLAINABLE (स्पष्ट): We can explain AI decisions to citizens (AI चे निर्णय नागरिकांना समजावून सांगता येतात)',
    ],
    warning: 'GOLDEN RULE: ALWAYS VERIFY AI OUTPUT. Think of AI as a junior assistant whose work you must review before signing off. (सुवर्ण नियम: AI चे आउटपुट नेहमी तपासा. AI ला एक कनिष्ठ सहाय्यक समजा ज्याचे काम तुम्ही स्वाक्षरी करण्यापूर्वी तपासले पाहिजे.)',
    keyTakeaway: 'AI CAN make mistakes: hallucinate facts, misunderstand context, provide outdated info. YOU are the final reviewer. (AI चुका करू शकते: तथ्ये तयार करू शकते, संदर्भ चुकीचा समजू शकते, कालबाह्य माहिती देऊ शकते. तुम्ही अंतिम पुनरावलोकनकर्ता आहात.)',
  },
  {
    id: 69,
    type: 'content',
    module: 9,
    title: 'Challenges: Bias, Privacy & Security',
    marathi: 'आव्हाने: पूर्वग्रह, गोपनीयता आणि सुरक्षा',
    content: 'Three critical challenges every government officer must understand: (प्रत्येक शासकीय अधिकाऱ्याला समजून घेणे आवश्यक असलेली तीन गंभीर आव्हाने:)',
    challenges: [
      {
        title: 'BIAS (पूर्वग्रह)',
        description: 'Amazon AI rejected women resumes because historical data was male-dominated. If AI filters housing subsidy applications, could it unfairly reject certain demographics? (Amazon AI ने महिलांचे रेझ्युमे नाकारले कारण ऐतिहासिक डेटा पुरुषप्रधान होता. AI गृहनिर्माण अनुदान अर्ज फिल्टर करत असल्यास, ते काही जनसांख्यिकीय गटांना अन्यायकारकपणे नाकारू शकते का?)',
        solution: 'Fix: Train AI on DIVERSE, FAIR, and AUDITED data. (उपाय: AI ला विविध, न्याय्य आणि लेखापरीक्षित डेटावर प्रशिक्षित करा.)',
      },
      {
        title: 'PRIVACY (गोपनीयता)',
        description: 'Cambridge Analytica harvested data from 87M Facebook users. The state holds sensitive citizen data: health records, land ownership, Aadhaar details. (Cambridge Analytica ने ८.७ कोटी Facebook वापरकर्त्यांचा डेटा गोळा केला. राज्याकडे संवेदनशील नागरिक डेटा आहे: आरोग्य नोंदी, जमीन मालकी, आधार तपशील.)',
        solution: 'NEVER upload sensitive citizen data into public, free AI tools! Use only enterprise-grade, government-approved AI tools. (संवेदनशील नागरिक डेटा कधीही सार्वजनिक, मोफत AI साधनांमध्ये अपलोड करू नका! फक्त एंटरप्राइझ-ग्रेड, शासन-मान्यताप्राप्त AI साधने वापरा.)',
      },
      {
        title: 'SECURITY & DEEPFAKES (सुरक्षा आणि डीपफेक्स)',
        description: 'AI can create fake videos and audio of leaders. Misinformation can cause public panic and erosion of trust. (AI नेत्यांचे बनावट व्हिडिओ आणि ऑडिओ तयार करू शकते. चुकीच्या माहितीमुळे जनतेत घबराट आणि विश्वास कमी होऊ शकतो.)',
        solution: 'Verify sources, use digital signatures, educate citizens: "Verify before sharing." (स्रोत तपासा, डिजिटल स्वाक्षऱ्या वापरा, नागरिकांना शिक्षित करा: "सामायिक करण्यापूर्वी तपासा.")',
      },
    ],
  },
  {
    id: 70,
    type: 'closing',
    module: 9,
    title: 'Summary & Thank You',
    marathi: 'सारांश आणि आभार',
    summary: [
      'AI is a TOOL, not a replacement. It learns from data to assist us - not replace human judgment. (AI एक साधन आहे, बदली नाही. ते डेटामधून शिकून आपल्याला मदत करते - मानवी निर्णयक्षमतेची जागा घेत नाही.)',
      'Generative AI is a powerful assistant. Use specific prompts to draft, summarize, translate, and brainstorm. (जनरेटिव्ह AI एक शक्तिशाली सहाय्यक आहे. मसुदा तयार करण्यासाठी, सारांश काढण्यासाठी, भाषांतर करण्यासाठी आणि विचारमंथन करण्यासाठी विशिष्ट प्रॉम्प्ट वापरा.)',
      'Public Sector Impact: AI can streamline administration when we train our workforce effectively. (सार्वजनिक क्षेत्रावर प्रभाव: आपण कार्यबलाला प्रभावीपणे प्रशिक्षित केल्यास AI प्रशासन सुव्यवस्थित करू शकते.)',
      'Ethics are non-negotiable. Be vigilant about bias, privacy - always keep a "Human in the Loop". (नैतिकता अपरिवर्तनीय आहे. पूर्वग्रह, गोपनीयतेबद्दल सतर्क राहा - नेहमी "मानवी नियंत्रण" ठेवा.)',
      'DO NOT FEAR AI - MANAGE IT. Start small, learn by doing, lead with confidence. (AI ला घाबरू नका - व्यवस्थापित करा. छोट्या गोष्टींपासून सुरुवात करा, करून शिका, आत्मविश्वासाने नेतृत्व करा.)',
    ],
    homework: [
      'Log into an AI tool this week - ChatGPT / Gemini / Copilot (या आठवड्यात AI साधनात लॉग इन करा - ChatGPT / Gemini / Copilot)',
      'Draft one standard office email using AI (AI वापरून एक मानक कार्यालय ईमेल तयार करा)',
      'Summarize one long document using AI (AI वापरून एका दीर्घ दस्तऐवजाचा सारांश काढा)',
      'Share your experience with a colleague (तुमचा अनुभव एका सहकाऱ्यासोबत सामायिक करा)',
    ],
    closingMessage: 'Thank you for your participation! You are now equipped to lead the AI transformation in Maharashtra. (तुमच्या सहभागाबद्दल धन्यवाद! आता तुम्ही महाराष्ट्रात AI परिवर्तनाचे नेतृत्व करण्यास सक्षम आहात.)',
    marathiClosing: 'जय महाराष्ट्र! जय हिंद!',
  },
];

export const moduleInfo = [
  { id: 1, title: 'Welcome & Introduction (स्वागत आणि प्रस्तावना)', slides: '1-6', duration: '20 min' },
  { id: 2, title: 'Understanding AI (AI समजून घेणे)', slides: '7-15', duration: '45 min' },
  { id: 3, title: 'How Does AI Work? (AI कसे काम करते?)', slides: '16-24', duration: '45 min' },
  { id: 4, title: 'Types of AI (AI चे प्रकार)', slides: '25-30', duration: '30 min' },
  { id: 0, title: 'Tea Break (चहा विश्रांती)', slides: '31', duration: '15 min' },
  { id: 5, title: 'Generative AI & Prompting (जनरेटिव्ह AI आणि प्रॉम्प्टिंग)', slides: '32-45', duration: '75 min' },
  { id: -1, title: 'Lunch Break (दुपारचे जेवण)', slides: '46', duration: '45 min' },
  { id: 6, title: 'AI Impact on Workforce (कर्मचाऱ्यांवर AI चा प्रभाव)', slides: '47-54', duration: '40 min' },
  { id: 7, title: 'AI in Your Department (तुमच्या विभागात AI)', slides: '55-62', duration: '40 min' },
  { id: 8, title: 'Professional Development (व्यावसायिक विकास)', slides: '63-66', duration: '25 min' },
  { id: 9, title: 'Ethics & Responsible AI (नैतिकता आणि जबाबदार AI)', slides: '67-70', duration: '25 min' },
];
